"use strict";

define([], function() {

    return {
        'values': {
            'en': {
                'invalidInputDefault': 'Please input a positive interger or nothing',
                'invalidInputNpi': 'Please input a positive interger',
                'frequency': 'Frequency',
                'dataRange': 'Date range',
                'customDate': 'Custom Date',
                'customStartDate': 'Start Date',
                'customEndDate': 'End Date',
                'labelSearch': 'Add assets to compare',
                'labelChange': 'Change Main Ticker',
                'eventsIndicators': 'Events & Indicators',
                'events': 'Events',
                'eventsDividende': 'Dividend',
                'eventsSplits': 'Splits',
                'eventsEarnings': 'Earnings',
                'indicators': 'Indicators',
                'indicatorsSMA': 'Simple Moving Average (SMA)',
                'indicatorsSMAlabel1': 'Line1 period',
                'indicatorsSMAlabel2': 'Line2 period',
                'indicatorsSMAlabel3': 'Line3 period',
                'indicatorsEMA': 'Exponential Moving Average (EMA)',
                'indicatorsEMAlabel1': 'Line1 period',
                'indicatorsEMAlabel2': 'Line2 period',
                'indicatorsEMAlabel3': 'Line3 period',
                'indicatorsVolume': 'Volume',
                'indicatorsVolumeSMA': 'Volume SMA',
                'indicatorsPeriod': 'Period',
                'indicatorsBBands': 'Bollinger Bands (BBands)',
                'indicatorsBBandsPeriod': 'Period',
                'indicatorsBBandsDeviation': 'Deviation',
                'indicatorsPSAR': 'Parabolic SAR (PSAR)',
                'indicatorsPSARStep': 'Step Period',
                'indicatorsPSARMaxStep': 'Max Step Period',
                'indicatorsMACD': 'MACD',
                'indicatorsMACDSlow': 'Slow Period',
                'indicatorsMACDFast': 'Fast Period',
                'indicatorsMACDSignal': 'Signal Period',
                'indicatorsRSI': 'Relative Strength Index (RSI)',
                'indicatorsRSIPeriod': 'Period',
                'indicatorsROC': 'Rate of Change (ROC)',
                'indicatorsROCPeriod': 'Period',
                'indicatorsCCI': 'Commodity Channel Index (CCI)',
                'indicatorsCCIPeriod': 'Period',
                'indicatorsSMAR': 'Williams %R',
                'indicatorsSMAPeriod': 'Period',
                'indicatorsSMASlow': 'Slow Stochastic',
                'indicatorsSMAK': 'K% Period',
                'indicatorsSMAD': 'D% Period',
                'indicatorsSMAFast': 'Fast Stochastic',
                'indicatorsSMAFastK': 'K% Period',
                'indicatorsSMAFastD': 'D% Period',
                'indicatorsSMAPrice': 'Price Channel',
                'indicatorsSMAPriceChannel': 'Price Channel',
                'indicatorsSMAMA': 'MA Envelope',
                'indicatorsSMAMAPeriod': 'Period',
                'indicatorsSMAMABand': 'Band Width',
                'indicatorsSMAMomentum': 'Momentum',
                'indicatorsSMAMomentumPeriod': 'Period',
                'indicatorsSMAULT': 'Ultimate (ULT) Oscillator',
                'indicatorsSMADMI': 'Directional Moving Index (DMI)',
                'indicatorsSMADMIPeriod': 'Period',
                'indicatorsSMAMoney': 'Money Flow Index',
                'indicatorsSMAMoneyPeriod': 'Period',
                'indicatorsSMAOBV': 'On Balance Volume',
                'indicatorsEMAVol': 'Volume Accumulation',
                'indicatorsEMADirect': 'Up/Down Ratio',
                'indicatorsEMADirectPeriodo': 'Period',
                'indicatorsEMADirectSmoothing': 'Smoothing',
                'indicatorsEMAVolume': 'Volume By Price',
                'indicatorsEMAFast': 'Fast Volatility',
                'indicatorsEMAWeight': 'Weighted Moving Average',
                'indicatorsEMAWeightPeriodo': 'Period',
                'indicatorsEMAAD': 'Accumulation/Distribution',
                'indicatorsEMAMass': 'Mass Index',
                'indicatorsEMAVolat': 'Volatility',
                'indicatorsEMAVolatPeriod': 'Period',
                'indicatorsEMAVolatPeriodA': 'Period Ago',
                'indicatorsEMAForce': 'Force Index',
                'indicatorsEMAForcePeriod': 'Period',
                'indicatorsEMARange': 'Average True Range',
                'indicatorsVolumeKeltner': 'Keltner Index',
                'indicatorsVolumeKeltnerEMA': 'EMA Period',
                'indicatorsVolumeKeltnerTimes': 'Times',
                'indicatorsVolumeKeltnerATR': 'ATR Period',
                'indicatorsVolumePrevious': 'Previous Close Line',
                'performanceGrowthChart': 'Performance Growth Chart',
                'pricesGrowthChart': 'Prices Growth Chart',
                'performanceGrowthChartance': 'Performance...',
                'update': 'Update',
                'fundamentals': 'Fundamentals',
                'priceEarnings': 'Price/Earnings',
                'priceSales': 'Price/Sales',
                'priceBook': 'Price/Book',
                'priceCash': 'Price/Cash',
                'fairValue': 'Fair Value',
                'rollingDividend': 'Rolling Dividend',
                'dividendYield': 'Dividend Yield',
                'rollingEPS': 'Rolling EPS',
                'drawings': 'Drawings',
                'trendLine': 'Trend Line',
                'rectangle': 'Rectangle',
                'ellipse': 'Ellipse',
                'levelLine': 'Level Line',
                'fibonacciRL': 'Fibonacci Retracement Levels',
                'fibonacciFans': 'Fibonacci Fans',
                'fibonacciTZ': 'Fibonacci Time Zones',
                'fibonacciArcs': 'Fibonacci Arcs',
                'shortInt': '% Short Int.',
                'priceEarnings0': 'Discount Cum Fair',
                'priceEarnings1': 'NAV',
                'priceEarnings2': 'Premium/Discount',
                'display': 'Display',
                'cursorType': 'Cursor Type',
                'crosshair': 'Crosshair',
                'trackBall': 'Track Ball',
                'off': 'Off',
                'chartType': 'Chart Type',
                'mountain': 'Mountain',
                'line': 'Line',
                'dot': 'Dot',
                'aboveBelow': 'Above/Below',
                'OHLC': 'OHLC',
                'HLC': 'HLC',
                'candlestick': 'Candlestick',
                'growth': 'Growth',
                '10KGrowth': '10K Growth',
                'priceWithDividendGrowth': 'Price with Dividend Growth',
                'dividendEffect': 'Dividend Effect',
                'postTax': 'Post Tax',
                'yAxis': 'Y-Axis',
                'left': 'Left',
                'right': 'Right',
                'verticalScale': 'Vertical Scale',
                'linear': 'Linear',
                'logarithmic': 'Logarithmic',
                'selectionMode': 'Selection Mode',
                'pan': 'Pan',
                'zoomIn': 'Zoom In',
                'reset': 'Reset',
                'other': 'Other',
                'extendedMarketHour': 'Extended Market Hour',
                'volumePlus': 'Volume+',
                'oneMinute': '1 min',
                'fiveMinute': "5 min",
                'tenMinute': "10 min",
                'fifteenMinute': "15 min",
                'thirtyMinute': "30 min",
                'sixtyMinute': "60 min",
                'daily': "Daily",
                'weekly': "Weekly",
                'monthly': "Monthly",
                'date': 'Date',
                'time': 'Time',
                'nav': 'NAV',
                'oneMinuteValueChange': '1 min Change',
                'oneMinuteValueChangePercent': '1 min % Change',
                'fiveMinuteValueChange': "5 min Change",
                'fiveMinuteValueChangePercent': "5 min % Change",
                'tenMinuteValueChange': "10 min Change",
                'tenMinuteValueChangePercent': "10 min % Change",
                'fifteenMinuteValueChange': "15 min Change",
                'fifteenMinuteValueChangePercent': "15 min % Change",
                'thirtyMinuteValueChange': "30 min Change",
                'thirtyMinuteValueChangePercent': "30 min % Change",
                'sixtyMinuteValueChange': "60 min Change",
                'sixtyMinuteValueChangePercent': "60 min % Change",
                'dailyValueChange': "Daily Change",
                'dailyValueChangePercent': "Daily % Change",
                'weeklyValueChange': "Weekly Change",
                'weeklyValueChangePercent': "Weekly % Change",
                'monthlyValueChange': "Monthly Change",
                'monthlyValueChangePercent': "Monthly % Change",
                'totalReturn': 'Total Return',
                'marketValue': 'Market Value',
                'open': 'Open',
                'close': 'Close',
                'low': 'Low',
                'high': 'High',
                'volume': 'Volume',
                'value': 'Value',
                'semiAnnual': 'Semi-annual',
                'annual': 'Annual',
                'quarterly': 'Quarterly',
                'mainGrowthLabel': 'Performance Fondo',
                'compareGrowthLabel': 'Performance Benchmark',
                'closeDateLabel': 'Data Chiusura Mercato',
                'range': 'Range',
                "datanotavailable": "Data not available",
                "mifidRuleMessage": "This graph and the related data will be available {0} months after the fund's inception date",
                'changetodailyfrequency': 'This is a daily data point. |Please change your frequency to Daily.',
                'tenKGrowth': '10K Growth',
                'postTax': 'Post Tax',
                'addComparison': 'Add Comparison',
                'changeTicker': 'Change Ticker',
                'searchAssets': 'Search assets',
                'crosshairsPopoverNoData': '--',
                'mainChartHeaderDividendEffectLabel': '(w Div.)',
                'compareChartsMaxAllowedErrorLabel': 'The maximum compare tickers are reached.',
                'oneDay': '1D',
                'fiveDay': '5D',
                'fifteenDay': '15D',
                'oneMonth': '1M',
                'threeMonth': '3M',
                'sixMonth': '6M',
                'YTD': 'YTD',
                'oneYear': '1Y',
                'threeYear': '3Y',
                'fiveYear': '5Y',
                'tenYear': '10Y',
                'max': 'MAX',
                'to': 'to',
                'frequencys': 'frequency',
                'dividendText': 'D',
                'splitText': 'S',
                'earningText': 'E',
                'settings': 'Settings',
                'optionsBtnText': 'Options',
                'export': 'Export',
                'print': 'Print',
                "closeBtnText": "Close",
                'errorsMsg': "Your mobile device can’t display some charting features. Log in from a tablet or computer for a better trading experience.",
                'fundSize': 'Fund Size',
                'price': 'Price',
                'shareholdersNumber': 'Number of shareholders',
                'name': 'Name',
                'PE': 'Price/Earnings',
                'PS': 'Price/Sales',
                'PB': 'Price/Book',
                'PC': 'Price/Cash',
                'FairValue': 'Fair Value',
                'DailyCumFairNav': 'NAV',
                'QuantitativeFairValue': 'Fair Value',
                'RDividend': 'Rolling Dividend',
                'DYield': 'Dividend Yield',
                'REPS': 'Rolling EPS',
                'PremiumDiscount': 'Premium/Discount',
                'DiscountCumFair': 'Discount Cum Fair',
                'SInterest': '% Short Int.',
                'SMA': 'SMA',
                'EMA': 'EMA',
                'SMAV': 'SMAV',
                'BBands': 'BBands',
                'PSAR': 'PSAR',
                'RSI': 'RSI',
                'ROC': 'ROC',
                'CCI': 'CCI',
                'WillR': 'WillR',
                'SStochastic': 'SStochastic',
                'FStochastic': 'FStochastic',
                'PChannel': 'PChannel',
                'MAE': 'MA Envelope',
                'Momentum': 'Momentum',
                'ULT': 'Ultimate Oscillator',
                'MFI': 'MFI',
                'OBV': 'On Balance Volume',
                'VAcc': 'Volume Accumulation',
                'UDRatio': 'UDRatio',
                'FVolatility': 'Fast Volatility',
                'WMA': 'WMA',
                'AccDis': 'Accumulation/Distribution',
                'Mass': 'Mass',
                'Volatility': 'Volatility',
                'ForceIndex': 'ForceIndex',
                'ATR': 'Average True Range',
                'Keltner': 'Keltner Index',
                'VBP': 'VBP',
                'DMI': ['DMI+', ' DMI-', ' ADX'],
                'MACD': ['MACD', 'EMA', 'Divergence'],
                'PrevClose': 'Previous Close',
                "mutualFund": "Mutual Fund",
                "closedEndFund": "Closed-End Fund",
                "equities": "Equities",
                "index": "Index",
                "eTF": "ETF",
                "commonStocks": "Common Stocks",
                "preferredStocks": "Preferred Stocks",
                "aDRs": "ADRs",
                "options": "Options",
                "futures": "Futures",
                "debenture": "Debenture",
                "governmentBonds": "Government Bonds",
                "municipalBonds": "Municipal Bonds",
                "strategiesSpreads": "Strategies & Spreads",
                "unspecifiedBonds": "Unspecified Bonds",
                "unspecifiedFundsCertificates": "Unspecified Funds & Certificates",
                "warrants": "Warrants",
                "forex": "Forex",
                "startDate": "Start Date",
                "earliest": "Earliest",
                "common": "Common",
                "mainTicker": "Main Ticker",
                "startDateIllustrate": "Indicate the base date when comparison added"
            },
            'fr': {
                'invalidInputDefault': 'Veuillez entrer une variable positive ou nulle',
                'invalidInputNpi': 'Veuillez entrer une variable positive',
                'frequency': 'Fréquence',
                'dataRange': 'Intervalle de dates',
                'customDate': 'Date personnalisé',
                'customStartDate': 'Date de début',
                'customEndDate': 'Date de fin',
                'labelSearch': 'Ajouter titre en comparaison',
                'labelChange': 'Changer le symbole',
                'eventsIndicators': 'Événements et indicateurs',
                'events': 'Événements',
                'eventsDividende': 'Dividende',
                'eventsSplits': 'Fractionnements',
                'eventsEarnings': 'Bénéfices',
                'indicators': 'Indicateurs',
                'indicatorsSMA': 'Moyenne mobile simple (MMA)',
                'indicatorsSMAlabel1': 'Période Ligne 1',
                'indicatorsSMAlabel2': 'Période Ligne 2',
                'indicatorsSMAlabel3': 'Période Ligne 3',
                'indicatorsEMA': 'Moyenne mobile exponentielle (MME)',
                'indicatorsEMAlabel1': 'Période Ligne 1',
                'indicatorsEMAlabel2': 'Période Ligne 2',
                'indicatorsEMAlabel3': 'Période Ligne 3',
                'indicatorsVolume': 'Volume',
                'indicatorsVolumeSMA': 'Moyenne mobile simple du volume',
                'indicatorsPeriod': 'Période',
                'indicatorsBBands': 'Bandes de Bollinger Bands (BBandes)',
                'indicatorsBBandsPeriod': 'Période',
                'indicatorsBBandsDeviation': 'Écart-type',
                'indicatorsPSAR': 'Parabolique SAR (PSAR)',
                'indicatorsPSARStep': 'Étape de valeur',
                'indicatorsPSARMaxStep': 'Valeur max de l\'indicateur',
                'indicatorsMACD': 'MACD',
                'indicatorsMACDSlow': 'Période lente',
                'indicatorsMACDFast': 'Période court terme',
                'indicatorsMACDSignal': 'Période de signal',
                'indicatorsRSI': 'Indice de force relative (RSI)',
                'indicatorsRSIPeriod': 'Période',
                'indicatorsROC': 'Taux de changement (TC)',
                'indicatorsROCPeriod': 'Période',
                'indicatorsCCI': 'Commodity Channel Index (CCI)',
                'indicatorsCCIPeriod': 'Période',
                'indicatorsSMAR': 'Williams %R',
                'indicatorsSMAPeriod': 'Période',
                'indicatorsSMASlow': 'Stochastique lente',
                'indicatorsSMAK': 'Période K%',
                'indicatorsSMAD': 'Période D%',
                'indicatorsSMAFast': 'Stochastique rapide',
                'indicatorsSMAFastK': 'Période K%',
                'indicatorsSMAFastD': 'Période D%',
                'indicatorsSMAPrice': 'Canale di prezzo',
                'indicatorsSMAPriceChannel': 'Canale di prezzo',
                'indicatorsSMAMA': 'Enveloppe MM',
                'indicatorsSMAMAPeriod': 'Période',
                'indicatorsSMAMABand': 'Bande de fréquence',
                'indicatorsSMAMomentum': 'Momentum',
                'indicatorsSMAMomentumPeriod': 'Période',
                'indicatorsSMAULT': 'Oscillateur ultime (ULT)',
                'indicatorsSMADMI': 'Indice di movimento direzionale (DMI)',
                'indicatorsSMADMIPeriod': 'Période',
                'indicatorsSMAMoney': 'Indice des flux monétaires',
                'indicatorsSMAMoneyPeriod': 'Période',
                'indicatorsSMAOBV': 'OBV',
                'indicatorsEMAVol': 'Accumulation de volume',
                'indicatorsEMADirect': 'Ratio volume hausse/baisse',
                'indicatorsEMADirectPeriodo': 'Période',
                'indicatorsEMADirectSmoothing': 'Lissage',
                'indicatorsEMAVolume': 'Volume par prix',
                'indicatorsEMAFast': 'Volatilité rapide',
                'indicatorsEMAWeight': 'Moyenne mobile pondérée',
                'indicatorsEMAWeightPeriodo': 'Période',
                'indicatorsEMAAD': 'Accumulation/distribution',
                'indicatorsEMAMass': 'Indice de masse',
                'indicatorsEMAVolat': 'Volatilité',
                'indicatorsEMAVolatPeriod': 'Période',
                'indicatorsEMAVolatPeriodA': 'Dernière période',
                'indicatorsEMAForce': 'Indice de force',
                'indicatorsEMAForcePeriod': 'Période',
                'indicatorsEMARange': 'Fourchette moyenne véritable',
                'indicatorsVolumeKeltner': 'Indice de Keltner',
                'indicatorsVolumeKeltnerEMA': 'Période mme',
                'indicatorsVolumeKeltnerTimes': 'Facteur',
                'indicatorsVolumeKeltnerATR': 'Période écart moyen réel',
                'indicatorsVolumePrevious': 'Cours de clôture de la veille',
                'performanceGrowthChart': 'Graphique Croissance Performance',
                'pricesGrowthChart': 'Graphique Croissance du prix',
                'performanceGrowthChartance': 'Performance…',
                'update': 'Mettre à jour',
                'fundamentals': 'Données fondamentales',
                'priceEarnings': 'Cours/bénéfices',
                'priceSales': 'Cours/ventes',
                'priceBook': 'Cours/valeur comptable',
                'priceCash': 'Cours/encaisse',
                'fairValue': 'Valeur juste',
                'rollingDividend': 'Dividende mobile',
                'dividendYield': 'Rendement de dividende',
                'rollingEPS': 'BPA mobile',
                'shortInt': '% ratio posit à découv',
                'priceEarnings0': 'Discount Cum Fair',
                'priceEarnings1': 'NAV',
                'priceEarnings2': 'Premium/Discount',
                'drawings': 'Dessin',
                'trendLine': 'Ligne de tendance',
                'rectangle': 'Rectangle',
                'ellipse': 'Ellipse',
                'levelLine': 'Ligne de niveau',
                'fibonacciRL': 'Niv. de retracements de Fibonacci',
                'fibonacciFans': 'Fanions de Fibonacci',
                'fibonacciTZ': 'Fuseaux horaires de Fibonacci',
                'fibonacciArcs': 'Arcs de Fibonacci',
                'shortInt': '% ratio posit à découv',
                'display': 'Affichage',
                'cursorType': 'Type de curseur',
                'crosshair': 'Réticule',
                'trackBall': 'Boule de commande',
                'off': 'Désactivé',
                'chartType': 'Style de graphique',
                'mountain': 'Montagne',
                'line': 'Ligne',
                'dot': 'Point',
                'aboveBelow': 'Au-dessus/au-dessous',
                'OHLC': 'OECB',
                'HLC': 'ECB',
                'candlestick': 'Graphique en chandelier',
                'growth': 'Croissance',
                '10KGrowth': 'Croissance de 10K',
                'priceWithDividendGrowth': 'Prix avec croissance des dividendes',
                'dividendEffect': 'Effet de dividende',
                'postTax': 'Poster d\'impôt',
                'yAxis': 'Axe Y',
                'left': 'Gauche',
                'right': 'Droite',
                'verticalScale': 'échelle verticale',
                'linear': 'Linéaire',
                'logarithmic': 'Logarythmique',
                'selectionMode': 'Mode de sélection',
                'pan': 'Panoramique',
                'zoomIn': 'Zoom avant',
                'reset': 'Réinitialiser',
                'other': 'Autre',
                'extendedMarketHour': 'Heures prolongées des marchés',
                'volumePlus': 'Volume+',
                'oneMinute': '1 min',
                'fiveMinute': "5 min",
                'tenMinute': "10 min",
                'fifteenMinute': "15 min",
                'thirtyMinute': "30 min",
                'sixtyMinute': "60 min",
                'daily': "Quotidien",
                'weekly': "Hebdo.",
                'monthly': "Mensuel",
                'date': 'Date',
                'time': 'Temps',
                'nav': 'NAV',
                'oneMinuteValueChange': '1 min Changement',
                'oneMinuteValueChangePercent': '1 min % Changement',
                'fiveMinuteValueChange': "5 min Changement",
                'fiveMinuteValueChangePercent': "5 min % Changement",
                'tenMinuteValueChange': "10 min Changement",
                'tenMinuteValueChangePercent': "10 min % Changement",
                'fifteenMinuteValueChange': "15 min Changement",
                'fifteenMinuteValueChangePercent': "15 min % Changement",
                'thirtyMinuteValueChange': "30 min Changement",
                'thirtyMinuteValueChangePercent': "30 min % Changement",
                'sixtyMinuteValueChange': "60 min Changement",
                'sixtyMinuteValueChangePercent': "60 min % Changement",
                'dailyValueChange': "Quotidien Changement",
                'dailyValueChangePercent': "Quotidien % Changement",
                'weeklyValueChange': "Hebdo Changement",
                'weeklyValueChangePercent': "Hebdo % Changement",
                'monthlyValueChange': "Mensuel Changement",
                'monthlyValueChangePercent': "Mensuel % Changement",
                'totalReturn': 'Retour total',
                'marketValue': 'Valeur marchande',
                'open': 'Ouverture',
                'close': 'Fermeture',
                'low': 'Bas',
                'high': 'Haut',
                'volume': 'Volume',
                'value': 'Valeur',
                'semiAnnual': 'Semi-annuel',
                'annual': 'Annuel',
                'quarterly': 'Trimestriel',
                'mainGrowthLabel': 'Performance Fondo',
                'compareGrowthLabel': 'Performance Benchmark',
                'closeDateLabel': 'Data Chiusura Mercato',
                'range': 'Fourchette',
                "datanotavailable": "Aucune donnée n‘est disponible",
                "mifidRuleMessage": "Ce graphique et les données relatifs seront disponible {0} mois suivant la création du fond.",
                'changetodailyfrequency': 'Ceci est un point de données par jour. |S\'il vous plaît changer votre fréquence quotidienne',
                'tenKGrowth': 'Croissance de 10K',
                'postTax': 'Après taxes',
                'addComparison': 'Ajouter Comparaison',
                'changeTicker': 'Changer le Ticker',
                'searchAssets': 'rechercher des actifs',
                'crosshairsPopoverNoData': '--',
                'mainChartHeaderDividendEffectLabel': '(w Div.)',
                'compareChartsMaxAllowedErrorLabel': 'Le nombre maximum de symboles à comparer est atteint.',
                'oneDay': '1J',
                'fiveDay': '5J',
                'fifteenDay': '15J',
                'oneMonth': '1M',
                'threeMonth': '3M',
                'sixMonth': '6M',
                'YTD': 'AAJ',
                'oneYear': '1A',
                'threeYear': '3A',
                'fiveYear': '5A',
                'tenYear': '10A',
                'max': 'MAX',
                'to': 'à',
                'frequencys': 'fréquence',
                'dividendText': 'D',
                'splitText': 'F',
                'earningText': 'B',
                'settings': 'Paramètres',
                'optionsBtnText': 'Options',
                'export': 'Exporter',
                'print': 'Imprimer',
                'closeBtnText': 'Fermer',
                'errorsMsg': 'Votre appareil mobile ne peut pas afficher certaines fonctionnalités de cartographie. Connectez-vous à partir d\'une tablette ou d\'un ordinateur pour une meilleure expérience commerciale.',
                'fundSize': 'Taille du fonds',
                'price': 'Prix',
                'shareholdersNumber': "Nombre d'actionnaires",
                'name': 'Nom',
                'PE': 'Cours/bénéfices',
                'PS': 'Cours/ventes',
                'PB': 'Cours/valeur comptable',
                'PC': 'Cours/encaisse',
                'FairValue': 'Valeur juste',
                'DailyCumFairNav': 'NAV',
                'QuantitativeFairValue': 'Juste valeur',
                'RDividend': 'Dividende mobile',
                'DYield': 'Rendement de dividende',
                'REPS': 'BPA mobile',
                'PremiumDiscount': 'Premium/Discount',
                'DiscountCumFair': 'Discount Cum Fair',
                'SInterest': '% ratio posit à découv',
                'SMA': 'MMA',
                'EMA': 'MME',
                'SMAV': 'MMSDV',
                'BBands': 'BBandes',
                'PSAR': 'PSAR',
                'RSI': 'RSI',
                'ROC': 'TC',
                'CCI': 'CCI',
                'WillR': 'Williams %R',
                'SStochastic': 'Stochastique lente',
                'FStochastic': 'Stochastique rapide',
                'PChannel': 'Canale di prezzo',
                'MAE': 'Enveloppe MM',
                'Momentum': 'Momentum',
                'ULT': 'Oscillateur ultime (ULT)',
                'MFI': 'Indice des flux monétaires',
                'OBV': 'OBV',
                'VAcc': 'Accumulation de volume',
                'UDRatio': 'Ratio volume hausse/baisse',
                'FVolatility': 'Volatilité rapide',
                'WMA': 'MMP',
                'AccDis': 'Accumulation/distribution',
                'Mass': 'Indice de masse',
                'Volatility': 'Volatilité',
                'ForceIndex': 'Indice de force',
                'ATR': 'Fourchette moyenne véritable',
                'Keltner': 'Indice de Keltner',
                'VBP': 'VPP',
                'DMI': ['DMI+', ' DMI-', ' ADX'],
                'MACD': ['MACD', 'EMA', 'Divergence'],
                'PrevClose': 'précédent fermer',
                "mutualFund": "Fonds communs de placement",
                "closedEndFund": "Fonds fermé",
                "equities": "Actions",
                "index": "Indice",
                "eTF": "ETF",
                "commonStocks": "Stocks communs",
                "preferredStocks": "Stocks préférés",
                "aDRs": "ADRs",
                "options": "Options",
                "futures": "Futures",
                "debenture": "Débenture",
                "governmentBonds": "Obligations d'État",
                "municipalBonds": "Les obligations municipales",
                "strategiesSpreads": "Stratégies et écarts",
                "unspecifiedBonds": "Obligations non spécifiées",
                "unspecifiedFundsCertificates": "Fonds et certificats non spécifiés",
                "warrants": "Warrants",
                "forex": "Forex",
                "startDate": "Date de début",
                "earliest": "La plus précoce",
                "common": "Commune",
                "mainTicker": "Symbole principal",
                "startDateIllustrate": "Indiquez la date de base à laquelle la comparaison a été ajoutée"
            },
            'fr-CA': {
                'invalidInputDefault': 'Veuillez entrer une variable positive ou nulle',
                'invalidInputNpi': 'Veuillez entrer une variable positive',
                'frequency': 'Fréquence',
                'dataRange': 'Intervalle de dates',
                'customDate': 'Date personnalisé',
                'customStartDate': 'Date de début',
                'customEndDate': 'Date de fin',
                'labelSearch': 'Ajouter titre en comparaison',
                'labelChange': 'Changer le symbole',
                'eventsIndicators': 'Événements et indicateurs',
                'events': 'Événements',
                'eventsDividende': 'Dividende',
                'eventsSplits': 'Fractionnements',
                'eventsEarnings': 'Bénéfices',
                'indicators': 'Indicateurs',
                'indicatorsSMA': 'Moyenne mobile simple (MMS)',
                'indicatorsSMAlabel1': 'Période Ligne 1',
                'indicatorsSMAlabel2': 'Période Ligne 2',
                'indicatorsSMAlabel3': 'Période Ligne 3',
                'indicatorsEMA': 'Moyenne mobile exponentielle (MME)',
                'indicatorsEMAlabel1': 'Période Ligne 1',
                'indicatorsEMAlabel2': 'Période Ligne 2',
                'indicatorsEMAlabel3': 'Période Ligne 3',
                'indicatorsVolume': 'Volume',
                'indicatorsVolumeSMA': 'Moyenne mobile simple du volume',
                'indicatorsPeriod': 'Période',
                'indicatorsBBands': 'Bandes de Bollinger (BandesB)',
                'indicatorsBBandsPeriod': 'Période',
                'indicatorsBBandsDeviation': 'Écart-type',
                'indicatorsPSAR': 'Parabolique SAR (PSAR)',
                'indicatorsPSARStep': 'Étape de valeur',
                'indicatorsPSARMaxStep': 'Valeur max de l\'indicateur',
                'indicatorsMACD': 'MACD',
                'indicatorsMACDSlow': 'Période lente',
                'indicatorsMACDFast': 'Période court terme',
                'indicatorsMACDSignal': 'Période de signal',
                'indicatorsRSI': 'Indice de force relative (IFR)',
                'indicatorsRSIPeriod': 'Période',
                'indicatorsROC': 'Taux de changement (TDC)',
                'indicatorsROCPeriod': 'Période',
                'indicatorsCCI': 'Commodity Channel Index (CCI)',
                'indicatorsCCIPeriod': 'Période',
                'indicatorsSMAR': 'Williams %R',
                'indicatorsSMAPeriod': 'Période',
                'indicatorsSMASlow': 'Stochastique lent',
                'indicatorsSMAK': 'Période K%',
                'indicatorsSMAD': 'Période D%',
                'indicatorsSMAFast': 'Stochastique rapide',
                'indicatorsSMAFastK': 'Période K%',
                'indicatorsSMAFastD': 'Période D%',
                'indicatorsSMAPrice': 'Canal de tendance',
                'indicatorsSMAPriceChannel': 'Canal de tendance',
                'indicatorsSMAMA': 'Enveloppe moyenne mobile',
                'indicatorsSMAMAPeriod': 'Période',
                'indicatorsSMAMABand': 'Bande de fréquence',
                'indicatorsSMAMomentum': 'Momentum',
                'indicatorsSMAMomentumPeriod': 'Période',
                'indicatorsSMAULT': 'Oscillateur ultime (ULT)',
                'indicatorsSMADMI': 'Indice de mouvement directionnel (DMI)',
                'indicatorsSMADMIPeriod': 'Période',
                'indicatorsSMAMoney': 'Indice du flux de capital',
                'indicatorsSMAMoneyPeriod': 'Période',
                'indicatorsSMAOBV': 'Indicateur OBV',
                'indicatorsEMAVol': 'Accumulation de volume',
                'indicatorsEMADirect': 'Ratio hausse/baisse',
                'indicatorsEMADirectPeriodo': 'Période',
                'indicatorsEMADirectSmoothing': 'Lissage',
                'indicatorsEMAVolume': 'Volume par prix',
                'indicatorsEMAFast': 'Volatilité rapide',
                'indicatorsEMAWeight': 'Moyenne mobile pondérée',
                'indicatorsEMAWeightPeriodo': 'Période',
                'indicatorsEMAAD': 'Accumulation/distribution',
                'indicatorsEMAMass': 'Indice MASS',
                'indicatorsEMAVolat': 'Volatilité',
                'indicatorsEMAVolatPeriod': 'Période',
                'indicatorsEMAVolatPeriodA': 'Dernière période',
                'indicatorsEMAForce': 'Indice de force relative',
                'indicatorsEMAForcePeriod': 'Période',
                'indicatorsEMARange': 'Fourchette moyenne véritable',
                'indicatorsVolumeKeltner': 'Indice de Keltner',
                'indicatorsVolumeKeltnerEMA': 'Période mme',
                'indicatorsVolumeKeltnerTimes': 'Facteur',
                'indicatorsVolumeKeltnerATR': 'Période écart moyen réel',
                'indicatorsVolumePrevious': 'Ligne de fermeture précédente',
                'performanceGrowthChart': 'Graphique Croissance Performance',
                'pricesGrowthChart': 'Graphique Croissance du prix',
                'performanceGrowthChartance': 'Performance…',
                'update': 'Mettre à jour',
                'fundamentals': 'Données fondam.',
                'priceEarnings': 'Cours/bénéfice',
                'priceSales': 'Cours/ventes',
                'priceBook': 'Cours/valeur comptable',
                'priceCash': 'Cours/flux de trésorerie',
                'fairValue': 'Juste valeur',
                'rollingDividend': 'Dividendes mobiles',
                'dividendYield': 'Rendement en dividendes',
                'rollingEPS': 'BPA mobile',
                'shortInt': '% Position à découvert',
                'priceEarnings0': 'Discount Cum Fair',
                'priceEarnings1': 'NAV',
                'priceEarnings2': 'Premium/Discount',
                'drawings': 'Dessin',
                'trendLine': 'Ligne de tendance',
                'rectangle': 'Rectangle',
                'ellipse': 'Ellipse',
                'levelLine': 'Ligne de niveau',
                'fibonacciRL': 'Niv. de retracements de Fibonacci',
                'fibonacciFans': 'Fanions de Fibonacci',
                'fibonacciTZ': 'Fuseaux horaires de Fibonacci',
                'fibonacciArcs': 'Arcs de Fibonacci',
                'display': 'Afficher',
                'cursorType': 'Type de graphique',
                'crosshair': 'Curseur en croix',
                'trackBall': 'Boule de commande',
                'off': 'Désactivé',
                'chartType': 'Type de graphique',
                'mountain': 'Graphique en montagne',
                'line': 'Graphique linéaire',
                'dot': 'Diagramme de dispersion',
                'aboveBelow': 'Supérieur/Inférieur',
                'OHLC': 'OHBF',
                'HLC': 'ECB',
                'candlestick': 'Graphique en chandelier',
                'growth': 'Croissance',
                '10KGrowth': 'Croissance de 10K',
                'priceWithDividendGrowth': 'Prix avec croissance des dividendes',
                'dividendEffect': 'Effet de dividende',
                'postTax': 'Poster d\'impôt',
                'yAxis': 'Axe Y',
                'left': 'Gauche',
                'right': 'Droite',
                'verticalScale': 'échelle verticale',
                'linear': 'Linéaire',
                'logarithmic': 'Logarithmique',
                'selectionMode': 'Mode de sélection',
                'pan': "Vue d'ensemble",
                'zoomIn': 'Zoom avant',
                'reset': 'Réinitialiser',
                'other': 'Autre',
                'extendedMarketHour': 'Heure d’ouverture prolongée',
                'volumePlus': 'Volume+',
                'oneMinute': '1 min',
                'fiveMinute': "5 min",
                'tenMinute': "10 min",
                'fifteenMinute': "15 min",
                'thirtyMinute': "30 min",
                'sixtyMinute': "60 min",
                'daily': "Quotidien",
                'weekly': "Hebdom.",
                'monthly': "Mensuel",
                'date': 'Date',
                'time': 'Temps',
                'nav': 'NAV',
                'oneMinuteValueChange': '1 min Changement',
                'oneMinuteValueChangePercent': '1 min % Changement',
                'fiveMinuteValueChange': "5 min Changement",
                'fiveMinuteValueChangePercent': "5 min % Changement",
                'tenMinuteValueChange': "10 min Changement",
                'tenMinuteValueChangePercent': "10 min % Changement",
                'fifteenMinuteValueChange': "15 min Changement",
                'fifteenMinuteValueChangePercent': "15 min % Changement",
                'thirtyMinuteValueChange': "30 min Changement",
                'thirtyMinuteValueChangePercent': "30 min % Changement",
                'sixtyMinuteValueChange': "60 min Changement",
                'sixtyMinuteValueChangePercent': "60 min % Changement",
                'dailyValueChange': "Quotidien Changement",
                'dailyValueChangePercent': "Quotidien % Changement",
                'weeklyValueChange': "Hebdo Changement",
                'weeklyValueChangePercent': "Hebdo % Changement",
                'monthlyValueChange': "Mensuel Changement",
                'monthlyValueChangePercent': "Mensuel % Changement",
                'totalReturn': 'Retour total',
                'marketValue': 'Valeur marchande',
                'open': 'Ouvrir',
                'close': 'Fermer',
                'low': 'Faible',
                'high': 'Élevé ',
                'volume': 'Volume',
                'value': 'Valeur',
                'semiAnnual': 'Semi-annuel',
                'annual': 'Annuel',
                'quarterly': 'Trimestriel',
                'mainGrowthLabel': 'Performance Fondo',
                'compareGrowthLabel': 'Performance Benchmark',
                'closeDateLabel': 'Data Chiusura Mercato',
                'range': 'Fourchette',
                "datanotavailable": "Aucune donnée n‘est disponible",
                'changetodailyfrequency': 'Ceci est un point de données par jour. |S\'il vous plaît changer votre fréquence quotidienne',
                'tenKGrowth': 'Croissance de 10K',
                'postTax': 'Après taxes',
                'addComparison': 'Ajouter Comparer',
                'changeTicker': 'Changer le Ticker',
                'searchAssets': 'rechercher des actifs',
                'crosshairsPopoverNoData': '--',
                'mainChartHeaderDividendEffectLabel': '(w Div.)',
                'compareChartsMaxAllowedErrorLabel': 'Le nombre maximum de symboles à comparer est atteint.',
                'oneDay': '1J',
                'fiveDay': '5J',
                'fifteenDay': '15J',
                'oneMonth': '1M',
                'threeMonth': '3M',
                'sixMonth': '6M',
                'YTD': 'AAJ',
                'oneYear': '1A',
                'threeYear': '3A',
                'fiveYear': '5A',
                'tenYear': '10A',
                'max': 'MAX',
                'to': 'à',
                'frequencys': 'fréquence',
                'dividendText': 'D',
                'splitText': 'F',
                'earningText': 'B',
                'settings': 'Paramètres',
                'optionsBtnText': 'Options',
                'export': 'Exporter',
                'print': 'Imprimer',
                'closeBtnText': 'Fermer',
                'errorsMsg': 'Votre appareil mobile ne peut pas afficher certaines fonctionnalités de cartographie. Connectez-vous à partir d\'une tablette ou d\'un ordinateur pour une meilleure expérience commerciale.',
                'fundSize': 'Taille du fonds',
                'price': 'Prix',
                'shareholdersNumber': "Nombre d'actionnaires",
                'name': 'Nom',
                'PE': 'Cours/bénéfice',
                'PS': 'Cours/ventes',
                'PB': 'Cours/valeur comptable',
                'PC': 'Cours/flux de trésorerie',
                'FairValue': 'Juste valeur',
                'DailyCumFairNav': 'NAV',
                'QuantitativeFairValue': 'Juste Valeur',
                'RDividend': 'Dividendes mobiles',
                'DYield': 'Rendement en dividendes',
                'REPS': 'BPA mobile',
                'PremiumDiscount': 'Premium/Discount',
                'DiscountCumFair': 'Discount Cum Fair',
                'SInterest': '% Position à découvert',
                'SMA': 'MMS',
                'EMA': 'MME',
                'SMAV': 'MMSDV',
                'BBands': 'Bbandes',
                'PSAR': 'PSAR',
                'RSI': 'RSI',
                'ROC': 'TDC',
                'CCI': 'CCI',
                'WillR': 'Williams %R',
                'SStochastic': 'Stochastique lent',
                'FStochastic': 'Stochastique rapide',
                'PChannel': 'Canal de tendance',
                'MAE': 'Enveloppe moyenne mobile',
                'Momentum': 'Momentum',
                'ULT': 'Oscillateur ultime (ULT)',
                'MFI': 'Indice du flux de capital',
                'OBV': 'Indicateur OBV',
                'VAcc': 'Accumulation de volume',
                'UDRatio': 'Ratio hausse/baisse',
                'FVolatility': 'Volatilité rapide',
                'WMA': 'MMP',
                'AccDis': 'Accumulation/distribution',
                'Mass': 'Indice MASS',
                'Volatility': 'Volatilité',
                'ForceIndex': 'Indice de force relative',
                'ATR': 'Fourchette moyenne véritable',
                'Keltner': 'Indice de Keltner',
                'VBP': 'VPP',
                'DMI': ['DMI+', ' DMI-', ' ADX'],
                'MACD': ['MACD', 'EMA', 'Divergence'],
                'PrevClose': 'précédent fermer',
                "mutualFund": "Fonds communs de placement",
                "closedEndFund": "Fonds fermé",
                "equities": "Actions",
                "index": "Indice",
                "eTF": "ETF",
                "commonStocks": "Stocks communs",
                "preferredStocks": "Stocks préférés",
                "aDRs": "ADRs",
                "options": "Options",
                "futures": "Futures",
                "debenture": "Débenture",
                "governmentBonds": "Obligations d'État",
                "municipalBonds": "Les obligations municipales",
                "strategiesSpreads": "Stratégies et écarts",
                "unspecifiedBonds": "Obligations non spécifiées",
                "unspecifiedFundsCertificates": "Fonds et certificats non spécifiés",
                "warrants": "Warrants",
                "forex": "Forex",
                "startDate": "Date de début",
                "earliest": "La plus précoce",
                "common": "Commune",
                "mainTicker": "Symbole principal",
                "startDateIllustrate": "Indiquez la date de base à laquelle la comparaison a été ajoutée",
                "mifidRuleMessage": "Ce graphique et les données relatifs seront disponible {0} mois suivant la création du fond.",
            },
            'it': {
                'invalidInputDefault': "Per favore inserisce un numero intero o nulla",
                'invalidInputNpi': "Per favore inserisce un numero intero",
                'frequency': "Frequenza",
                'dataRange': "Intervallo",
                'customDate': "Periodo personalizzato",
                'customStartDate': "Inizio",
                'customEndDate': "Fine",
                'labelSearch': "Aggiungi titolo per confronto",
                'labelChange': 'Changer le ticker principal',
                'eventsIndicators': "Eventi e Indicatori",
                'events': "Eventi",
                'eventsDividende': "Dividendi",
                'eventsSplits': "Operazioni Capitale",
                'eventsEarnings': "Utili",
                'indicators': "Indicatori",
                'indicatorsSMA': "Media mobile semplice",
                'indicatorsSMAlabel1': "Periodo linea 1",
                'indicatorsSMAlabel2': "Periodo linea 2",
                'indicatorsSMAlabel3': "Periodo linea 3",
                'indicatorsEMA': "Media mobile esponenziale (MME)",
                'indicatorsEMAlabel1': "Periodo linea 1",
                'indicatorsEMAlabel2': "Periodo linea 2",
                'indicatorsEMAlabel3': "Periodo linea 3",
                'indicatorsVolume': "Volume",
                'indicatorsVolumeSMA': "Volume MME",
                'indicatorsPeriod': "Periodo",
                'indicatorsBBands': "Bande di Bollinger",
                'indicatorsBBandsPeriod': "Periodo",
                'indicatorsBBandsDeviation': "Deviazione",
                'indicatorsPSAR': "Parabolic SAR",
                'indicatorsPSARStep': "Step Period",
                'indicatorsPSARMaxStep': "Max Step Period",
                'indicatorsMACD': "MACD",
                'indicatorsMACDSlow': "Periodo lento",
                'indicatorsMACDFast': "Periodo veloce",
                'indicatorsMACDSignal': "Periodo MME",
                'indicatorsRSI': "Indicatore di forza relativa (RSI)",
                'indicatorsRSIPeriod': "Periodo",
                'indicatorsROC': "Rate of Change (ROC)",
                'indicatorsROCPeriod': "Periodo",
                'indicatorsCCI': 'Commodity Channel Index (CCI)',
                'indicatorsCCIPeriod': 'Periodo',
                'indicatorsSMAR': "Williams %R",
                'indicatorsSMAPeriod': "Periodo",
                'indicatorsSMASlow': "Stocastico lento",
                'indicatorsSMAK': "Periodo K",
                'indicatorsSMAD': "Periodo D",
                'indicatorsSMAFast': "Stocastico veloce",
                'indicatorsSMAFastK': "Periodo K",
                'indicatorsSMAFastD': "Periodo D",
                'indicatorsSMAPrice': "Canale di prezzo",
                'indicatorsSMAPriceChannel': "Canale di prezzo",
                'indicatorsSMAMA': "MA Envelope",
                'indicatorsSMAMAPeriod': "Periodo",
                'indicatorsSMAMABand': "Band Width",
                'indicatorsSMAMomentum': "Momentum",
                'indicatorsSMAMomentumPeriod': "Periodo",
                'indicatorsSMAULT': "Ultimate (ULT) Oscillator",
                'indicatorsSMADMI': "Indice di movimento direzionale (DMI)",
                'indicatorsSMADMIPeriod': "Periodo",
                'indicatorsSMAMoney': "Flusso monetario (MF)",
                'indicatorsSMAMoneyPeriod': "Periodo",
                'indicatorsSMAOBV': "On Balance Volume",
                'indicatorsEMAVol': "Volume Accumulation",
                'indicatorsEMADirect': "Up/Down",
                'indicatorsEMADirectPeriodo': "Periodo",
                'indicatorsEMADirectSmoothing': "Smoothing",
                'indicatorsEMAVolume': "Volume per prezzo",
                'indicatorsEMAFast': "Fast Volatility",
                'indicatorsEMAWeight': "Media mobile ponderata",
                'indicatorsEMAWeightPeriodo': "Periodo",
                'indicatorsEMAAD': "Accumulazione/Distribuzione",
                'indicatorsEMAMass': "Mass Index",
                'indicatorsEMAVolat': "Volatilità",
                'indicatorsEMAVolatPeriod': "Periodo",
                'indicatorsEMAVolatPeriodA': "Period Ago",
                'indicatorsEMAForce': "Force Index",
                'indicatorsEMAForcePeriod': "Periodo",
                'indicatorsEMARange': "Average True Range",
                'indicatorsVolumeKeltner': "Keltner Index",
                'indicatorsVolumeKeltnerEMA': "Periodo MME",
                'indicatorsVolumeKeltnerTimes': "Times",
                'indicatorsVolumeKeltnerATR': "Periodo ATR",
                'indicatorsVolumePrevious': "Prezzo di chiusura",
                'performanceGrowthChart': "Performance Fondo e Benchmark",
                'pricesGrowthChart': "Andamento Valore Quota",
                'performanceGrowthChartance': "Rendimento…",
                'update': "Aggiornamento",
                'fundamentals': "Fondamentali",
                'priceEarnings': "P/E (Prezzo/Utile)",
                'priceSales': "P/S (Prezzo/Fatturato)",
                'priceBook': "P/B (Prezzo/Valore contabile",
                'priceCash': "P/C (Prezzo/Cash)",
                'fairValue': "Fair Value",
                'rollingDividend': "Rolling Dividend",
                'dividendYield': "Dividend Yield",
                'rollingEPS': "Rolling EPS",
                'drawings': "Disegna",
                'trendLine': "Linea di trend",
                'rectangle': "Rettangolo",
                'ellipse': "Ellisse",
                'levelLine': "Linea di livello",
                'fibonacciRL': "Ritracciamenti di Fibonacci",
                'fibonacciFans': "Fan line di Fibonacci",
                'fibonacciTZ': "Time zone di Fibonacci",
                'fibonacciArcs': "Archi di Fibonacci",
                'shortInt': "% Short Int.",
                'priceEarnings0': "Discount Cum Fair",
                'priceEarnings1': "NAV",
                'priceEarnings2': "Premio/Sconto",
                'display': "Mostra",
                'cursorType': "Tipo di cursore",
                'crosshair': "Crosshair",
                'trackBall': "Track Ball",
                'off': "Chiudi",
                'chartType': "Tipo grafico",
                'mountain': "Montagna",
                'line': "Lineare",
                'dot': "Dot",
                'aboveBelow': "Sopra/Sotto",
                'OHLC': "Barre (OHLC)",
                'HLC': "HLC",
                'candlestick': "Candele",
                'growth': "Crescita",
                '10KGrowth': "10K Crescita",
                'priceWithDividendGrowth': 'Prezzo con crescita dei dividendi',
                'dividendEffect': "Effetto dividendo",
                'postTax': "Post Tax",
                'yAxis': "Asse Y",
                'left': "Sinistra",
                'right': "Destra",
                'verticalScale': "Scala verticale",
                'linear': "Lineare",
                'logarithmic': "Logaritmica",
                'selectionMode': "Modalità di selezione",
                'pan': "Pannello",
                'zoomIn': "Ingrandire",
                'reset': "Reset",
                'other': "Altro",
                'extendedMarketHour': "Estendi ore di mercato",
                'volumePlus': "Volume+",
                'oneMinute': '1 min',
                'fiveMinute': "5 min",
                'tenMinute': "10 min",
                'fifteenMinute': "15 min",
                'thirtyMinute': "30 min",
                'sixtyMinute': "60 min",
                'daily': "Quotidiano",
                'weekly': "settimanale",
                'monthly': "Mensile",
                'date': "Data",
                'time': "Ora",
                'nav': "NAV",
                'oneMinuteValueChange': '1 min Cambio',
                'oneMinuteValueChangePercent': '1 min % Cambio',
                'fiveMinuteValueChange': "5 min Cambio",
                'fiveMinuteValueChangePercent': "5 min % Cambio",
                'tenMinuteValueChange': "10 min Cambio",
                'tenMinuteValueChangePercent': "10 min % Cambio",
                'fifteenMinuteValueChange': "15 min Cambio",
                'fifteenMinuteValueChangePercent': "15 min % Cambio",
                'thirtyMinuteValueChange': "30 min Cambio",
                'thirtyMinuteValueChangePercent': "30 min % Cambio",
                'sixtyMinuteValueChange': "60 min Cambio",
                'sixtyMinuteValueChangePercent': "60 min % Cambio",
                'dailyValueChange': "Quotidiano Cambio",
                'dailyValueChangePercent': "Quotidiano % Cambio",
                'weeklyValueChange': "settimanale Cambio",
                'weeklyValueChangePercent': "settimanale % Cambio",
                'monthlyValueChange': "Mensile Cambio",
                'monthlyValueChangePercent': "Mensile % Cambio",
                'totalReturn': "Rendimento totale",
                'marketValue': "Valore di mercato",
                'open': "Pzo apertura",
                'close': "Pzo chiusura",
                'low': "Min",
                'high': "Max",
                'volume': "Volume",
                'value': "Ultimo prezzo",
                'semiAnnual': "Semiannuale",
                'annual': "Annuale",
                'quarterly': "Trimestrale",
                'mainGrowthLabel': "Performance Fondo",
                'compareGrowthLabel': "Performance Benchmark",
                'closeDateLabel': "Data Chiusura Mercato",
                'range': "Intervallo",
                'datanotavailable': "Dati non disponibili",
                "mifidRuleMessage": "Questo grafico e i relativi dati saranno disponibili {0} mesi dopo la data di inizio del fondo",
                'changetodailyfrequency': "Questo è un dato giornaliero. Modifica la frequenza per una corretta visualizzazione.",
                'tenKGrowth': "10K Crescita",
                'postTax': "Post Tax",
                'addComparison': "Confronta",
                'changeTicker': 'Cambio Ticker',
                'searchAssets': "Cerca titolo",
                'crosshairsPopoverNoData': "--",
                'mainChartHeaderDividendEffectLabel': "(w Div.)",
                'compareChartsMaxAllowedErrorLabel': "Hai raggiunto il massimo numero di Ticker.",
                'oneDay': "1G",
                'fiveDay': "5G",
                'fifteenDay': "15G",
                'oneMonth': "1M",
                'threeMonth': "3M",
                'sixMonth': "6M",
                'YTD': "YTD",
                'oneYear': "1A",
                'threeYear': "3A",
                'fiveYear': "5A",
                'tenYear': "10A",
                'max': "Max",
                'to': "a",
                'frequencys': "frequenza",
                'dividendText': "D",
                'splitText': "S",
                'earningText': "U",
                'settings': "Impostazioni",
                'optionsBtnText': "Opzioni",
                'export': "Esporta",
                'print': "stampa",
                'closeBtnText': "Chiudi",
                'errorsMsg': "Il dispositivo non è in grado di visualizzare alcune caratteristiche del grafico. Collegati da un different dispositivo o un computer per una migliore esperienza di trading.",
                'fundSize': 'dimensioni del fondo',
                'price': 'Prezzo',
                'shareholdersNumber': 'Numero di azionisti',
                'name': 'Nome',
                'PE': 'P/E (Prezzo/Utile)',
                'PS': 'P/S (Prezzo/Fatturato)',
                'PB': 'P/B (Prezzo/Valore contabile',
                'PC': 'P/C (Prezzo/Cash)',
                'FairValue': 'Fair Value',
                'DailyCumFairNav': 'NAV',
                'QuantitativeFairValue': 'Fair Value',
                'RDividend': 'Rolling Dividend',
                'DYield': 'Dividend Yield',
                'REPS': 'Rolling EPS',
                'PremiumDiscount': 'Premio/Sconto',
                'DiscountCumFair': 'Discount Cum Fair',
                'SInterest': '% Short Int.',
                'SMA': 'MMS',
                'EMA': 'MME',
                'SMAV': 'Volume MME',
                'BBands': 'Bande di Bollinger',
                'PSAR': 'Parabolic SAR',
                'RSI': 'RSI',
                'ROC': 'ROC',
                'CCI': 'CCI',
                'WillR': 'Williams %R',
                'SStochastic': 'Stocastico lento',
                'FStochastic': 'Stocastico veloce',
                'PChannel': 'Canale di prezzo',
                'MAE': 'MA Envelope',
                'Momentum': 'Momentum',
                'ULT': 'Ultimate (ULT) Oscillator',
                'MFI': 'Flusso monetario (MF)',
                'OBV': 'On Balance Volume',
                'VAcc': 'Volume Accumulation',
                'UDRatio': 'Up/Down',
                'FVolatility': 'Fast Volatility',
                'WMA': 'WMP',
                'AccDis': 'Accumulazione/Distribuzione',
                'Mass': 'Mass Index',
                'Volatility': 'Volatilità',
                'ForceIndex': 'Force Index',
                'ATR': 'Average True Range',
                'Keltner': 'Keltner Index',
                'VBP': 'VBP',
                'DMI': ['DMI+', ' DMI-', ' ADX'],
                'MACD': ['MACD', 'EMA', 'Divergence'],
                'PrevClose': 'chiusura precedente',
                "mutualFund": "Fondo comune",
                "closedEndFund": "Fondo chiuso",
                "equities": "Indice",
                "index": "Index",
                "eTF": "ETF",
                "commonStocks": "Azioni comuni",
                "preferredStocks": "Azioni preferite",
                "aDRs": "ADRs",
                "options": "Opzioni",
                "futures": "Futures",
                "debenture": "obbligazione",
                "governmentBonds": "Obbligazioni statali",
                "municipalBonds": "Obbligazioni municipali",
                "strategiesSpreads": "Strategie e diffusioni",
                "unspecifiedBonds": "Obbligazioni non specificate",
                "unspecifiedFundsCertificates": "Fondi e certificati non specificati",
                "warrants": "Warrants",
                "forex": "Forex",
                "startDate": "Start Date",
                "earliest": "Earliest",
                "common": "Common",
                "mainTicker": "Main Ticker",
                "startDateIllustrate": "Indicate the base date when comparison added"
            },
            'es': {
                'invalidInputDefault': "Por favor, introduzca un número positivo o nada",
                'invalidInputNpi': "Por favor, introduzca un número positivo",
                'frequency': "Frecuencia",
                'dataRange': "Rango de fechas",
                'customDate': "Fecha personalizada",
                'customStartDate': "Fecha de inicio",
                'customEndDate': "Fecha final",
                'labelSearch': "Añada activos a comparar",
                'labelChange': 'Cambiar el ticker principal',
                'eventsIndicators': "Eventos e indicadores",
                'events': "Eventos",
                'eventsDividende': "Dividendos",
                'eventsSplits': "Splits",
                'eventsEarnings': "Ganancias",
                'indicators': "Indicadores",
                'indicatorsSMA': "Media Móvil Simple (SMA)",
                'indicatorsSMAlabel1': "Periodo Línea1",
                'indicatorsSMAlabel2': "Periodo Línea2",
                'indicatorsSMAlabel3': "Periodo Línea3",
                'indicatorsEMA': "Media Móvil Exponencial (EMA)",
                'indicatorsEMAlabel1': "Periodo Línea1",
                'indicatorsEMAlabel2': "Periodo Línea2",
                'indicatorsEMAlabel3': "Periodo Línea3",
                'indicatorsVolume': "Volumen",
                'indicatorsVolumeSMA': "Volumen SMA",
                'indicatorsPeriod': "Periodo",
                'indicatorsBBands': "Las Bandas de bollinger (BBands)",
                'indicatorsBBandsPeriod': "Periodo",
                'indicatorsBBandsDeviation': "Desviación",
                'indicatorsPSAR': "SAR parabólico (PSAR)",
                'indicatorsPSARStep': "Step Period",
                'indicatorsPSARMaxStep': "Step Period Max",
                'indicatorsMACD': "MACD",
                'indicatorsMACDSlow': "Periodo lento",
                'indicatorsMACDFast': "Periodo rápido ",
                'indicatorsMACDSignal': "Signal Period",
                'indicatorsRSI': "Relative Strength Index (RSI)",
                'indicatorsRSIPeriod': "Periodo",
                'indicatorsROC': "Rate of Change (ROC)",
                'indicatorsROCPeriod': "Periodo",
                'indicatorsCCI': 'Commodity Channel Index (CCI)',
                'indicatorsCCIPeriod': 'Periodo',
                'indicatorsSMAR': "Williams %R",
                'indicatorsSMAPeriod': "Periodo",
                'indicatorsSMASlow': "Estocástico lento",
                'indicatorsSMAK': "K% Periodo",
                'indicatorsSMAD': "D% Periodo",
                'indicatorsSMAFast': "Estocástico rápido",
                'indicatorsSMAFastK': "K% Periodo",
                'indicatorsSMAFastD': "D% Periodo",
                'indicatorsSMAPrice': "Canal de precios",
                'indicatorsSMAPriceChannel': "Canal de precios",
                'indicatorsSMAMA': "MA Envelope",
                'indicatorsSMAMAPeriod': "Periodo",
                'indicatorsSMAMABand': "Band Width",
                'indicatorsSMAMomentum': "Momentum",
                'indicatorsSMAMomentumPeriod': "Periodo",
                'indicatorsSMAULT': "Ultimate (ULT) Oscillator",
                'indicatorsSMADMI': "Índice de movimiento direccional (DMI)",
                'indicatorsSMADMIPeriod': "Periodo",
                'indicatorsSMAMoney': "Flujo monetario (MF)",
                'indicatorsSMAMoneyPeriod': "Periodo",
                'indicatorsSMAOBV': "On Balance Volume",
                'indicatorsEMAVol': "Acumulación de volumen",
                'indicatorsEMADirect': "Ratio Up/Down",
                'indicatorsEMADirectPeriodo': "Periodo",
                'indicatorsEMADirectSmoothing': "Smoothing",
                'indicatorsEMAVolume': "Volumen por precio",
                'indicatorsEMAFast': "Volatilidad rápida",
                'indicatorsEMAWeight': "Media móvil ponderada",
                'indicatorsEMAWeightPeriodo': "Periodo",
                'indicatorsEMAAD': "Acumulación / Distribución",
                'indicatorsEMAMass': "Mass Index",
                'indicatorsEMAVolat': "Volatilidad",
                'indicatorsEMAVolatPeriod': "Periodo",
                'indicatorsEMAVolatPeriodA': "Periodo anterior",
                'indicatorsEMAForce': "Force Index",
                'indicatorsEMAForcePeriod': "Periodo",
                'indicatorsEMARange': "Average True Range",
                'indicatorsVolumeKeltner': "Índice Keltner ",
                'indicatorsVolumeKeltnerEMA': "Periodo EMA",
                'indicatorsVolumeKeltnerTimes': "Horarios",
                'indicatorsVolumeKeltnerATR': "Periodo ATR ",
                'indicatorsVolumePrevious': "Linea de cierre previo",
                'performanceGrowthChart': "Gráfico de crecimiento ",
                'pricesGrowthChart': "Gráfico de precios",
                'performanceGrowthChartance': "Rentabilidad…",
                'update': "Actualización",
                'fundamentals': "Fundamentales",
                'priceEarnings': "P/Beneficio",
                'priceSales': "Precio/Ventas",
                'priceBook': "Precio/Valor contable",
                'priceCash': "P/CF",
                'fairValue': "Fair Value",
                'rollingDividend': "Rolling Dividend",
                'dividendYield': "Rentabilidad dividendo",
                'rollingEPS': "Rolling EPS",
                'drawings': "Dibujos",
                'trendLine': "Línea de tendencia",
                'rectangle': "Rectángulo",
                'ellipse': "Elipse",
                'levelLine': "Línea nivel",
                'fibonacciRL': "Fibonacci Retracement Levels",
                'fibonacciFans': "Fibonacci Fans",
                'fibonacciTZ': "Fibonacci Time Zones",
                'fibonacciArcs': "Fibonacci Arcs",
                'shortInt': "% Short Int.",
                'priceEarnings0': "Discount Cum Fair",
                'priceEarnings1': "Valor liquidativo",
                'priceEarnings2': "Prima/Descuento",
                'display': "Visualizar",
                'cursorType': "Tipo de cursor",
                'crosshair': "Retículo",
                'trackBall': "Track Ball",
                'off': "Desactivar",
                'chartType': "Tipo de gráfico",
                'mountain': "Montaña",
                'line': "Línea",
                'dot': "Punto",
                'aboveBelow': "Encima/Debajo",
                'OHLC': "OHLC",
                'HLC': "HLC",
                'candlestick': "Velas",
                'growth': "Crecimiento",
                '10KGrowth': "Crecimiento 10k",
                "priceWithDividendGrowth": "Precio con Crecimiento Dividendo",
                'dividendEffect': "Efecto Dividendo",
                'postTax': "Post-impuestos",
                'yAxis': "Eje Y",
                'left': "Izquierda",
                'right': "Derecha",
                'verticalScale': "Escala vertical",
                'linear': "Lineal",
                'logarithmic': "Logarítmica",
                'selectionMode': "Modo de selección",
                'pan': "Panel",
                'zoomIn': "Ampliar",
                'reset': "Resetear",
                'other': "Otros",
                'extendedMarketHour': "Horario mercado extandido",
                'volumePlus': "Volumen+",
                'oneMinute': "1 min",
                'fiveMinute': "5 min",
                'tenMinute': "5 min",
                'fifteenMinute': "15 min",
                'thirtyMinute': "30 min",
                'sixtyMinute': "60 min",
                'daily': "Diario",
                'weekly': "Semanal",
                'monthly': "Mensual",
                'date': "Fecha",
                'time': "Hora",
                'nav': "Valor liquidativo",
                'oneMinuteValueChange': '1 min Cambio',
                'oneMinuteValueChangePercent': '1 min % Cambio',
                'fiveMinuteValueChange': "5 min Cambio",
                'fiveMinuteValueChangePercent': "5 min % Cambio",
                'tenMinuteValueChange': "10 min Cambio",
                'tenMinuteValueChangePercent': "10 min % Cambio",
                'fifteenMinuteValueChange': "15 min Cambio",
                'fifteenMinuteValueChangePercent': "15 min % Cambio",
                'thirtyMinuteValueChange': "30 min Cambio",
                'thirtyMinuteValueChangePercent': "30 min % Cambio",
                'sixtyMinuteValueChange': "60 min Cambio",
                'sixtyMinuteValueChangePercent': "60 min % Cambio",
                'dailyValueChange': "Diario Cambio",
                'dailyValueChangePercent': "Diario % Cambio",
                'weeklyValueChange': "Semanal Cambio",
                'weeklyValueChangePercent': "Semanal % Cambio",
                'monthlyValueChange': "Mensual Cambio",
                'monthlyValueChangePercent': "Mensual % Cambio",
                'totalReturn': "Rentabilidad total",
                'marketValue': "Valor mercado",
                'open': "Precio apertura",
                'close': "Precio cierre",
                'low': "Min",
                'high': "Max",
                'volume': "Volumen",
                'value': "Valor mercado",
                'semiAnnual': "Semianual",
                'annual': "Anual",
                'quarterly': "Trimestral",
                'mainGrowthLabel': "Rendimiento fondo",
                'compareGrowthLabel': "Rendimiento benchmark",
                'closeDateLabel': "Fecha cierre mercado",
                'range': "Rango",
                'datanotavailable': "Fecha no disponible",
                "mifidRuleMessage": "Este gráfico y los datos relacionados estarán disponibles {0} meses después de la fecha de inicio del fondo.",
                'changetodailyfrequency': "Esto es un dato diario. | por favor, cambie su frecuencia a diaria.",
                'tenKGrowth': "Crecimiento 10k",
                'postTax': "Post-impuestos",
                'addComparison': "Añadir comparación",
                "changeTicker": "Cambiar el ticker",
                'searchAssets': "Buscar activos",
                'crosshairsPopoverNoData': "--",
                'mainChartHeaderDividendEffectLabel': "(w Div.)",
                'compareChartsMaxAllowedErrorLabel': "Alcanzado el número máximo de tickers comparables",
                'oneDay': "1D",
                'fiveDay': "5D",
                'fifteenDay': "15D",
                'oneMonth': "1M",
                'threeMonth': "3M",
                'sixMonth': "6M",
                'YTD': "YTD",
                'oneYear': "1A",
                'threeYear': "3A",
                'fiveYear': "5A",
                'tenYear': "10A",
                'max': "MAX",
                'to': "a",
                'frequencys': "frecuencia",
                'dividendText': "D",
                'splitText': "S",
                'earningText': "E",
                'settings': "Ajustes",
                'optionsBtnText': "Opciones",
                'export': "Exportar",
                'print': "Impresión",
                'closeBtnText': "Cerrar",
                'errorsMsg': "Su dispositivo móvil no puede mostrar ciertas funciones gráficas. Acceda desde una tablet o un pc para mejorar su experiencia de trading",
                'fundSize': 'tamaño del fondo',
                'price': 'Precio',
                'shareholdersNumber': 'Número de accionista',
                'name': 'Nombre',
                'PE': 'P/Beneficio',
                'PS': 'Precio/Ventas',
                'PB': 'Precio/Valor contable',
                'PC': 'P/CF',
                'FairValue': 'Fair Value',
                'DailyCumFairNav': 'Valor liquidativo',
                'QuantitativeFairValue': 'Fair Value',
                'RDividend': 'Rolling Dividend',
                'DYield': 'Rentabilidad dividendo',
                'REPS': 'Rolling EPS',
                'PremiumDiscount': 'Prima/Descuento',
                'DiscountCumFair': 'Discount Cum Fair',
                'SInterest': '% Short Int.',
                'SMA': 'SMA',
                'EMA': 'EMA',
                'SMAV': 'SMAV',
                'BBands': 'BBAnds',
                'PSAR': 'SAR parabólico (PSAR)',
                'RSI': 'RSI',
                'ROC': 'ROC',
                'CCI': 'CCI',
                'WillR': 'Williams %R',
                'SStochastic': 'Estocástico lento',
                'FStochastic': 'Estocástico rápido',
                'PChannel': 'Canal de precios',
                'MAE': 'MA Envelope',
                'Momentum': 'Momentum',
                'ULT': 'Ultimate Oscillator (ULT)',
                'MFI': 'Flujo monetario (MFI)',
                'OBV': 'On Balance Volume',
                'VAcc': 'Acumulación de volumen',
                'UDRatio': 'Ratio UD',
                'FVolatility': 'Volatilidad rápida',
                'WMA': 'WMA',
                'AccDis': 'Acumulación / Distribución',
                'Mass': 'Mass Index',
                'Volatility': 'Volatilidad',
                'ForceIndex': 'ForceIndex',
                'ATR': 'Average True Range',
                'Keltner': 'Keltner Index',
                'VBP': 'VBP',
                'DMI': ['DMI+', ' DMI-', ' ADX'],
                'MACD': ['MACD', 'EMA', 'Divergence'],
                'PrevClose': 'cierre anterior',
                "mutualFund": "Fondo de inversión",
                "closedEndFund": "Fondo cerrado",
                "equities": "Acciones",
                "index": "Índice",
                "eTF": "ETF",
                "commonStocks": "Acciones ordinarias",
                "preferredStocks": "Acciones preferidas",
                "aDRs": "ADRs",
                "options": "Opciones",
                "futures": "Futuros",
                "debenture": "Obligación",
                "governmentBonds": "Bonos del gobierno",
                "municipalBonds": "Bonos municipales",
                "strategiesSpreads": "Estrategias y Spreads",
                "unspecifiedBonds": "Bonos no especificados",
                "unspecifiedFundsCertificates": "Fondos no especificados y certificados",
                "warrants": "Warrants",
                "forex": "Forex",
                "startDate": "Fecha de inicio",
                "earliest": "Apertura",
                "common": "Común",
                "mainTicker": "Ticker principal",
                "startDateIllustrate": "Indique la fecha base cuando se agregó la comparación"
            },
            'de': {
                'invalidInputDefault': "Bitte eine positive ganze Zahl eingeben oder leer lassen",
                'invalidInputNpi': "Bitte eine positive ganze Zahl eingeben",
                'frequency': "Frequenz",
                'dataRange': "Datumsbereich",
                'customDate': "Benutzerdefiniertes Datum",
                'customStartDate': "Startdatum",
                'customEndDate': "Enddatum",
                'labelSearch': "Hinzufügen von Werten zwecks Vergleich",
                'labelChange': 'Hauptticker wechseln',
                'eventsIndicators': "Events & Indikatoren",
                'events': "Events",
                'eventsDividende': "Dividende",
                'eventsSplits': "Split",
                'eventsEarnings': "Gewinn",
                'indicators': "Indikatoren",
                'indicatorsSMA': "Einfacher gleitender Mittelwert",
                'indicatorsSMAlabel1': "Zeitraum Linie 1",
                'indicatorsSMAlabel2': "Zeitraum Linie 2",
                'indicatorsSMAlabel3': "Zeitraum Linie 3",
                'indicatorsEMA': "Exponentieller gleitender Mittelwert",
                'indicatorsEMAlabel1': "Zeitraum Linie 1",
                'indicatorsEMAlabel2': "Zeitraum Linie 2",
                'indicatorsEMAlabel3': "Zeitraum Linie 3",
                'indicatorsVolume': "Volumen",
                'indicatorsVolumeSMA': "Volumen SMA",
                'indicatorsPeriod': "Zeitraum",
                'indicatorsBBands': "Bollinger Bänder",
                'indicatorsBBandsPeriod': "Zeitraum",
                'indicatorsBBandsDeviation': "Abweichung",
                'indicatorsPSAR': "Parabolic SAR (PSAR)",
                'indicatorsPSARStep': "Step Period",
                'indicatorsPSARMaxStep': "Max Step Period",
                'indicatorsMACD': "MACD",
                'indicatorsMACDSlow': "Slow Period",
                'indicatorsMACDFast': "Fast Period",
                'indicatorsMACDSignal': "Signal Period",
                'indicatorsRSI': "Relative Stärke Index (RSI)",
                'indicatorsRSIPeriod': "Zeitraum",
                'indicatorsROC': "Rate of Change (ROC)",
                'indicatorsROCPeriod': "Zeitraum",
                'indicatorsCCI': 'Commodity Channel Index (CCI)',
                'indicatorsCCIPeriod': 'Zeitraum',
                'indicatorsSMAR': "Williams %R",
                'indicatorsSMAPeriod': "Zeitraum",
                'indicatorsSMASlow': "Slow Stochastic",
                'indicatorsSMAK': "K% Zeitraum",
                'indicatorsSMAD': "D% Zeitraum",
                'indicatorsSMAFast': "Fast Stochastic",
                'indicatorsSMAFastK': "K% Zeitraum",
                'indicatorsSMAFastD': "D% Zeitraum",
                'indicatorsSMAPrice': "Price Channel",
                'indicatorsSMAPriceChannel': "Price Channel",
                'indicatorsSMAMA': "MA Envelope",
                'indicatorsSMAMAPeriod': "Zeitraum",
                'indicatorsSMAMABand': "Bandbreite",
                'indicatorsSMAMomentum': "Momentum",
                'indicatorsSMAMomentumPeriod': "Zeitraum",
                'indicatorsSMAULT': "Ultimate (ULT) Oscillator",
                'indicatorsSMADMI': "Directional Moving Index (DMI)",
                'indicatorsSMADMIPeriod': "Zeitraum",
                'indicatorsSMAMoney': "Money Flow Index",
                'indicatorsSMAMoneyPeriod': "Zeitraum",
                'indicatorsSMAOBV': "On Balance Volume",
                'indicatorsEMAVol': "Volume Accumulation",
                'indicatorsEMADirect': "Up/Down Ratio",
                'indicatorsEMADirectPeriodo': "Zeitraum",
                'indicatorsEMADirectSmoothing': "Glättung",
                'indicatorsEMAVolume': "Volume By Price",
                'indicatorsEMAFast': "Fast Volatility",
                'indicatorsEMAWeight': "Gewichteter gleitender Mittelwert",
                'indicatorsEMAWeightPeriodo': "Zeitraum",
                'indicatorsEMAAD': "Thesaurierung/Ausschüttung",
                'indicatorsEMAMass': "Mass Index",
                'indicatorsEMAVolat': "Volatilität",
                'indicatorsEMAVolatPeriod': "Zeitraum",
                'indicatorsEMAVolatPeriodA': "Vorangehender Zeitraum",
                'indicatorsEMAForce': "Force Index",
                'indicatorsEMAForcePeriod': "Zeitraum",
                'indicatorsEMARange': "Average True Range",
                'indicatorsVolumeKeltner': "Keltner Index",
                'indicatorsVolumeKeltnerEMA': "EMA Period",
                'indicatorsVolumeKeltnerTimes': "Times",
                'indicatorsVolumeKeltnerATR': "ATR Period",
                'indicatorsVolumePrevious': "Linie Schlusskurs Vortag",
                'performanceGrowthChart': "Performance Grafik",
                'pricesGrowthChart': "Kursentwicklungs-Grafik",
                'performanceGrowthChartance': "Performance…",
                'update': "Aktualisieren",
                'fundamentals': "Fundamentals",
                'priceEarnings': "Kurs/Gewinn",
                'priceSales': "Kurs/Umsatz",
                'priceBook': "Kurs/Buchwert",
                'priceCash': "Kurs/Cashflow",
                'fairValue': "Fair Value",
                'rollingDividend': "Rolling Dividend",
                'dividendYield': "Dividend Yield",
                'rollingEPS': "Rolling EPS",
                'drawings': "Drawings",
                'trendLine': "Trendlinie",
                'rectangle': "Rechteck",
                'ellipse': "Ellipse",
                'levelLine': "Level Line",
                'fibonacciRL': "Fibonacci Retracement Levels",
                'fibonacciFans': "Fibonacci Fans",
                'fibonacciTZ': "Fibonacci Time Zones",
                'fibonacciArcs': "Fibonacci Arcs",
                'shortInt': "% Short Int.",
                'priceEarnings0': "Discount Cum Fair",
                'priceEarnings1': "NAV",
                'priceEarnings2': "Premium/Discount",
                'display': "Darstellung",
                'cursorType': "Cursor Typ",
                'crosshair': "Fadenkreuz",
                'trackBall': "Trackball",
                'off': "Off",
                'chartType': "Chart Typ",
                'mountain': "Mountain",
                'line': "Linie",
                'dot': "Punkt",
                'aboveBelow': "Über/Unter",
                'OHLC': "OHLC",
                'HLC': "HLC",
                'candlestick': "Candlestick",
                'growth': "Wachstum",
                '10KGrowth': "10k Wachstum",
                'priceWithDividendGrowth': 'Preis mit Dividendenwachstum',
                'dividendEffect': "Dividendeneffekt",
                'postTax': "Nach Steuern",
                'yAxis': "Y-Achse",
                'left': "Links",
                'verticalScale': "Senkrechte Skala",
                'linear': "linear",
                'selectionMode': "Selektionsmodus",
                'pan': "Pan",
                'zoomIn': "Zoom in",
                'reset': "Reset",
                'other': "Andere",
                'extendedMarketHour': "Nachbörse",
                'oneMinute': '1 min',
                'fiveMinute': "5 min",
                'tenMinute': "10 min",
                'fifteenMinute': "15 min",
                'thirtyMinute': "30 min",
                'sixtyMinute': "60 min",
                'daily': "Täglich",
                'weekly': "wöchentlich",
                'monthly': "Monatliche",
                'date': "Datum",
                'time': "Zeit",
                'nav': "NAV",
                'oneMinuteValueChange': '1 min Wechsel',
                'oneMinuteValueChangePercent': '1 min % Wechsel',
                'fiveMinuteValueChange': "5 min Wechsel",
                'fiveMinuteValueChangePercent': "5 min % Wechsel",
                'tenMinuteValueChange': "10 min Wechsel",
                'tenMinuteValueChangePercent': "10 min % Wechsel",
                'fifteenMinuteValueChange': "15 min Wechsel",
                'fifteenMinuteValueChangePercent': "15 min % Wechsel",
                'thirtyMinuteValueChange': "30 min Wechsel",
                'thirtyMinuteValueChangePercent': "30 min % Wechsel",
                'sixtyMinuteValueChange': "60 min Wechsel",
                'sixtyMinuteValueChangePercent': "60 min % Wechsel",
                'dailyValueChange': "Täglich Wechsel",
                'dailyValueChangePercent': "Täglich % Wechsel",
                'weeklyValueChange': "wöchentlich Wechsel",
                'weeklyValueChangePercent': "wöchentlich % Wechsel",
                'monthlyValueChange': "Monatliche Wechsel",
                'monthlyValueChangePercent': "Monatliche % Wechsel",
                'totalReturn': "Gesamtertrag",
                'marketValue': "Marktwert",
                'open': "Eröffnungskurs",
                'close': "Schlusskurs",
                'low': "Niedrigstkurs",
                'high': "Höchstkurs",
                'volume': "Volumen",
                'value': "Wert",
                'semiAnnual': "Halbjährlich",
                'annual': "Jährlich",
                'quarterly': "Quartalsweise",
                'mainGrowthLabel': "Fondsperformance",
                'compareGrowthLabel': "Performance Vergleichsindex",
                'closeDateLabel': "Data Chiusura Mercato",
                'range': "Intervall",
                'datanotavailable': "Daten nicht verfügbar",
                "mifidRuleMessage": "Diese Grafik und die zugehörigen Daten werden {0} Monate nach Auflegung des Fonds verfügbar sein",
                'changetodailyfrequency': "Dieser Datenpunkt wird täglich erhoben. Bitte wechseln Sie zu täglicher Frequenz.",
                'tenKGrowth': "10k Wachstum",
                'postTax': "Nach Steuern",
                'addComparison': "Vergleich hinzufügen",
                "changeTicker": "Ticker wechseln",
                'searchAssets': "Suche nach Titeln",
                'crosshairsPopoverNoData': "--",
                'mainChartHeaderDividendEffectLabel': "(w Div.)",
                'compareChartsMaxAllowedErrorLabel': "Das Maximum der zu vergleichenden Werte ist erreicht.",
                'oneDay': "1T",
                'fiveDay': "5T",
                'fifteenDay': "15T",
                'oneMonth': "1M",
                'threeMonth': "3M",
                'sixMonth': "6M",
                'YTD': "YTD",
                'oneYear': "1J",
                'threeYear': "3J",
                'fiveYear': "5J",
                'tenYear': "10J",
                'max': "MAX",
                'to': "zu",
                'frequencys': "Frequenz",
                'dividendText': "D",
                'splitText': "S",
                'earningText': "G",
                'settings': "Einstellungen",
                'optionsBtnText': "Optionen",
                'export': "Export",
                'print': "Drucken",
                'closeBtnText': "Schliessen",
                'errorsMsg': "Ihr mobiles Gerät kann einige Funktionalitäten im Chart nicht darstellen. Für eine bessere Darstellung wechseln Sie bitte zu einem Tablet oder",
                'fundSize': 'Fondsvermögen',
                'price': 'Preis',
                'shareholdersNumber': 'Número de accionista',
                'name': 'Name',
                'PE': 'Kurs/Gewinn',
                'PS': 'Kurs/Umsatz',
                'PB': 'Kurs/Buchwert',
                'PC': 'Kurs/Cashflow',
                'FairValue': 'Fair Value',
                'RDividend': 'Rolling Dividend',
                'DailyCumFairNav': 'NAV',
                'DiscountCumFair': 'Discount Cum Fair',
                'QuantitativeFairValue': 'Fair Value',
                'DYield': 'Dividend Yield',
                'REPS': 'Rolling EPS',
                'PremiumDiscount': 'Premium/Discount',
                'SInterest': '% Short Int.',
                'SMA': 'EGM',
                'EMA': 'ETGM',
                'SMAV': 'SMAV',
                'BBands': 'Bollinger Bänder',
                'PSAR': 'PSAR',
                'RSI': 'RSI',
                'ROC': 'ROC',
                'CCI': 'CCI',
                'WillR': 'WillR',
                'SStochastic': 'SStochastic',
                'FStochastic': 'FStochastic',
                'PChannel': 'PChannel',
                'MAE': 'MA Envelope',
                'Momentum': 'Momentum',
                'ULT': 'Ultimate Oscillator',
                'MFI': 'MFI',
                'OBV': 'On Balance Volume',
                'VAcc': 'Volume Accumulation',
                'UDRatio': 'UDRatio',
                'FVolatility': 'Fast Volatility',
                'WMA': 'GGM',
                'AccDis': 'Thesaurierung/Ausschüttung',
                'Mass': 'Mass',
                'Volatility': 'Volatility',
                'ForceIndex': 'ForceIndex',
                'ATR': 'Average True Range',
                'Keltner': 'Keltner Index',
                'VBP': 'VBP',
                'DMI': ['DMI+', ' DMI-', ' ADX'],
                'MACD': ['MACD', 'EMA', 'Divergence'],
                'PrevClose': 'vorheriges Schließen',
                "mutualFund": "Investmentfonds",
                "closedEndFund": "Geschlossener Fonds",
                "equities": "Aktien",
                "index": "Index",
                "eTF": "ETF",
                "commonStocks": "Stammaktien",
                "preferredStocks": "Bevorzugte Aktien",
                "aDRs": "ADRs",
                "options": "Optionen",
                "futures": "Futures",
                "debenture": "Schuldverschreibung",
                "governmentBonds": "Staatsanleihen",
                "municipalBonds": "Kommunalanleihen",
                "strategiesSpreads": "Strategien & Spreads",
                "unspecifiedBonds": "Nicht näher bezeichnete Anleihen",
                "unspecifiedFundsCertificates": "Nicht spezifizierte Fonds und Zertifikate",
                "warrants": "Warrants",
                "forex": "Forex",
                "startDate": "Start Date",
                "earliest": "Earliest",
                "common": "Common",
                "mainTicker": "Main Ticker",
                "startDateIllustrate": "Indicate the base date when comparison added"
            },
            'pt': {
                "invalidInputDefault": "Por favor, introduza um número positivo ou nada.",
                "invalidInputNpi": "Por favor, introduza um número negativo ou nada.",
                "frequency": "Frequência",
                "dataRange": "Intervalo de datas",
                "customDate": "Data personalizada",
                "customStartDate": "Data inicial",
                "customEndDate": "Data final",
                "labelSearch": "Adicione ativos para comparar",
                'labelChange': 'Alterar o ticker principal',
                "eventsIndicators": "Eventos e indicadores",
                "events": "Eventos",
                "eventsDividende": "Dividendo",
                "eventsSplits": "Splits",
                "eventsEarnings": "Ganhos",
                "indicators": "Indicadores",
                "indicatorsSMA": "Média Móvel Simples (SMA)",
                "indicatorsSMAlabel1": "Periodo Linha1",
                "indicatorsSMAlabel2": "Periodo Linha2",
                "indicatorsSMAlabel3": "Periodo Linha3",
                "indicatorsEMA": "Média Móvel Exponencial",
                "indicatorsEMAlabel1": "Periodo Linha1",
                "indicatorsEMAlabel2": "Periodo Linha2",
                "indicatorsEMAlabel3": "Periodo Linha3",
                "indicatorsVolume": "Volume",
                "indicatorsVolumeSMA": "Volume SMA",
                "indicatorsPeriod": "Periodo",
                "indicatorsBBands": "Bandas de Bollinger",
                "indicatorsBBandsPeriod": "Periodo",
                "indicatorsBBandsDeviation": "Desvio",
                "indicatorsPSAR": "Parabolic SAR (PSAR)",
                "indicatorsPSARStep": "Step Period",
                "indicatorsPSARMaxStep": "Step Period Max",
                "indicatorsMACD": "MACD",
                "indicatorsMACDSlow": "Slow Period",
                "indicatorsMACDFast": "Fast Period",
                "indicatorsMACDSignal": "Signal Period",
                "indicatorsRSI": "Relative Strength Index (RSI)",
                "indicatorsRSIPeriod": "Período",
                "indicatorsROC": "Rate of Change (ROC)",
                "indicatorsROCPeriod": "Período",
                'indicatorsCCI': 'Commodity Channel Index (CCI)',
                'indicatorsCCIPeriod': 'Período',
                "indicatorsSMAR": "Williams %R",
                "indicatorsSMAPeriod": "Período",
                "indicatorsSMASlow": "Slow Stochastic",
                "indicatorsSMAK": "K% Período",
                "indicatorsSMAD": "D% Período",
                "indicatorsSMAFast": "Fast Stochastic",
                "indicatorsSMAFastK": "K% Período",
                "indicatorsSMAFastD": "D% Período",
                "indicatorsSMAPrice": "Price Channel",
                "indicatorsSMAPriceChannel": "Price Channel",
                "indicatorsSMAMA": "MA Envelope",
                "indicatorsSMAMAPeriod": "Período",
                "indicatorsSMAMABand": "Band Width",
                "indicatorsSMAMomentum": "Momentum",
                "indicatorsSMAMomentumPeriod": "Período",
                "indicatorsSMAULT": "Ultimate (ULT) Oscillator",
                "indicatorsSMADMI": "Directional Moving Index (DMI)",
                "indicatorsSMADMIPeriod": "Período",
                "indicatorsSMAMoney": "Money Flow Index",
                "indicatorsSMAMoneyPeriod": "Período",
                "indicatorsSMAOBV": "On Balance Volume",
                "indicatorsEMAVol": "Volume Accumulation",
                "indicatorsEMADirect": "Up/Down Ratio",
                "indicatorsEMADirectPeriodo": "Período",
                "indicatorsEMADirectSmoothing": "Smoothing",
                "indicatorsEMAVolume": "Volume por Preço",
                "indicatorsEMAFast": "Fast Volatility",
                "indicatorsEMAWeight": "Weighted Moving Average",
                "indicatorsEMAWeightPeriodo": "Período",
                "indicatorsEMAAD": "Acumulação / Distribuição",
                "indicatorsEMAMass": "Mass Index",
                "indicatorsEMAVolat": "Volatilidade",
                "indicatorsEMAVolatPeriod": "Período",
                "indicatorsEMAVolatPeriodA": "Periodo anterior",
                "indicatorsEMAForce": "Force Index",
                "indicatorsEMAForcePeriod": "Período",
                "indicatorsEMARange": "Average True Range",
                "indicatorsVolumeKeltner": "Keltner Index",
                "indicatorsVolumeKeltnerEMA": "EMA Period",
                "indicatorsVolumeKeltnerTimes": "Horários",
                "indicatorsVolumeKeltnerATR": "ATR Period",
                "indicatorsVolumePrevious": "Linha de fechamento prévio",
                "performanceGrowthChart": "Gráfico de Performance",
                "pricesGrowthChart": "Gráfico de Preços",
                "performanceGrowthChartance": "Rentabilidade...",
                "update": "Atualizar",
                "fundamentals": "Fundamentos",
                "priceEarnings": "Price/Earnings",
                "priceSales": "Price/Sales",
                "priceBook": "Price/Book",
                "priceCash": "Price/Cash",
                "fairValue": "Fair Value",
                "rollingDividend": "Rolling Dividend",
                "dividendYield": "Dividend Yield",
                "rollingEPS": "Rolling EPS",
                "drawings": "Desenhos",
                "trendLine": "Linha de tendência",
                "rectangle": "Retângulo",
                "ellipse": "Elipse",
                "levelLine": "Linha de nível",
                "fibonacciRL": "Fibonacci Retracement Levels",
                "fibonacciFans": "Fibonacci Fans",
                "fibonacciTZ": "Fibonacci Time Zones",
                "fibonacciArcs": "Fibonacci Arcs",
                "shortInt": "% Short Int.",
                "priceEarnings0": "Discount Cum Fair",
                "priceEarnings1": "Cota",
                "priceEarnings2": "Premium/Discount",
                "display": "Visualizar",
                "cursorType": "Tipo de cursor",
                "crosshair": "Crosshair",
                "trackBall": "Track Ball",
                "off": "Desativar",
                "chartType": "Tipo de gráfico",
                "mountain": "Mountain",
                "line": "Linha",
                "dot": "Ponto",
                "aboveBelow": "Above/Below",
                "OHLC": "OHLC",
                "HLC": "HLC",
                "candlestick": "Candlestick",
                "growth": "Crescimento",
                "10KGrowth": "Crescimento 10k",
                'priceWithDividendGrowth': 'Preço com Crescimento de Dividendos',
                "dividendEffect": "Efeito de Dividendos",
                "postTax": "Rentabilidade pós impostos",
                "yAxis": "Eixo Y",
                "left": "Esquerda",
                "right": "Direita",
                "verticalScale": "Escala vertical",
                "linear": "Linear",
                "logarithmic": "Logarítmico",
                "selectionMode": "Modo de seleção",
                "pan": "Pan",
                "zoomIn": "Zoom In",
                "reset": "Reset",
                "other": "Outros",
                "extendedMarketHour": "Horário de Mercado Extendido",
                "volumePlus": "Volume+",
                'oneMinute': '1 min',
                'fiveMinute': "5 min",
                'tenMinute': "10 min",
                'fifteenMinute': "15 min",
                'thirtyMinute': "30 min",
                'sixtyMinute': "60 min",
                'daily': "diária",
                'weekly': "semanal",
                'monthly': "mensal",
                "date": "Data",
                "time": "Hora",
                "nav": "Cota",
                'oneMinuteValueChange': '1 min Mudança',
                'oneMinuteValueChangePercent': '1 min % Mudança',
                'fiveMinuteValueChange': "5 min Mudança",
                'fiveMinuteValueChangePercent': "5 min % Mudança",
                'tenMinuteValueChange': "10 min Mudança",
                'tenMinuteValueChangePercent': "10 min % Mudança",
                'fifteenMinuteValueChange': "15 min Mudança",
                'fifteenMinuteValueChangePercent': "15 min % Mudança",
                'thirtyMinuteValueChange': "30 min Mudança",
                'thirtyMinuteValueChangePercent': "30 min % Mudança",
                'sixtyMinuteValueChange': "60 min Mudança",
                'sixtyMinuteValueChangePercent': "60 min % Mudança",
                'dailyValueChange': "diária Mudança",
                'dailyValueChangePercent': "diária % Mudança",
                'weeklyValueChange': "semanal Mudança",
                'weeklyValueChangePercent': "semanal % Mudança",
                'monthlyValueChange': "mensal Mudança",
                'monthlyValueChangePercent': "mensal % Mudança",
                "totalReturn": "Rentabilidade Total",
                "marketValue": "Valor de mercado",
                "open": "Abertura",
                "close": "Fechamento",
                "low": "Mínima",
                "high": "Máxima",
                "volume": "Volume",
                "value": "Valor de mercado",
                "semiAnnual": "Semi anual",
                "annual": "Anual",
                "quarterly": "Trimestral",
                "mainGrowthLabel": "Rendimento do fundo",
                "compareGrowthLabel": "Rendimento do benchmark",
                "closeDateLabel": "Data fechamento do mercado",
                "range": "Intervalo",
                "datanotavailable": "Data não disponível",
                "mifidRuleMessage": "Este gráfico e os dados relacionados estarão disponíveis {0} meses após a data de início do fundo.",
                "changetodailyfrequency": "Este é um dado diário. | Por favor mude a frequência para Diário.",
                "tenKGrowth": "Crescimento 10k",
                "postTax": "Rentabilidade pós impostos",
                "addComparison": "Adicionar Comparação",
                "changeTicker": "Alterar Ticker",
                "searchAssets": "Procurar ativos",
                "crosshairsPopoverNoData": "--",
                "mainChartHeaderDividendEffectLabel": "(w Div.)",
                "compareChartsMaxAllowedErrorLabel": "Alcançado o número máximo de ativos para comparação",
                "oneDay": "1D",
                "fiveDay": "5D",
                "fifteenDay": "15D",
                "oneMonth": "1M",
                "threeMonth": "3M",
                "sixMonth": "6M",
                "YTD": "YTD",
                "oneYear": "1A",
                "threeYear": "3A",
                "fiveYear": "5A",
                "tenYear": "10A",
                "max": "MAX",
                "to": "a",
                "frequencys": "Frequência",
                "dividendText": "D",
                "splitText": "S",
                "earningText": "E",
                "settings": "Configurações",
                "optionsBtnText": "Opções",
                "export": "Exportar",
                "print": "Impressão",
                "closeBtnText": "Fechar",
                "errorsMsg": "Seu dispositivo móvel não pode mostrar alguns gráficos. Conecte-se a um tablet ou computador para uma melhor experiência.",
                'fundSize': 'Patrimônio Líquido',
                'price': 'Preço',
                'shareholdersNumber': 'Número de cotistas',
                'name': 'Nome',
                'PE': 'Price/Earnings',
                'PS': 'Price/Sales',
                'PB': 'Price/Book',
                'PC': 'Price/Cash',
                'FairValue': 'Fair Value',
                'RDividend': 'Rolling Dividend',
                'DailyCumFairNav': 'NAV',
                'DiscountCumFair': 'Discount Cum Fair',
                'QuantitativeFairValue': 'Fair Value',
                'DYield': 'Dividend Yield',
                'REPS': 'Rolling EPS',
                'PremiumDiscount': 'Premium/Discount',
                'SInterest': '% Short Int.',
                'SMA': 'SMA',
                'EMA': 'MME',
                'SMAV': 'SMAV',
                'BBands': 'Bandas de Bollinger',
                'PSAR': 'PSAR',
                'RSI': 'RSI',
                'ROC': 'ROC',
                'CCI': 'CCI',
                'WillR': 'WillR',
                'SStochastic': 'SStochastic',
                'FStochastic': 'FStochastic',
                'PChannel': 'PChannel',
                'MAE': 'MA Envelope',
                'Momentum': 'Momentum',
                'ULT': 'Ultimate Oscillator',
                'MFI': 'MFI',
                'OBV': 'On Balance Volume',
                'VAcc': 'Volume Accumulation',
                'UDRatio': 'UDRatio',
                'FVolatility': 'Fast Volatility',
                'WMA': 'WMA',
                'AccDis': 'Acumulação / Distribuição',
                'Mass': 'Mass',
                'Volatility': 'Volatilidade',
                'ForceIndex': 'ForceIndex',
                'ATR': 'Average True Range',
                'Keltner': 'Keltner Index',
                'VBP': 'VBP',
                'DMI': ['DMI+', ' DMI-', ' ADX'],
                'MACD': ['MACD', 'EMA', 'Divergence'],
                'PrevClose': 'fechamento prévio',
                "mutualFund": "Fundos de Investimento",
                "closedEndFund": "Fundos Fechados",
                "equities": "Equities",
                "index": "Index",
                "eTF": "ETF",
                "commonStocks": "Estoques comuns",
                "preferredStocks": "Stocks preferenciais",
                "aDRs": "ADRs",
                "options": "Opções",
                "futures": "Futuros",
                "debenture": "Debênture",
                "governmentBonds": "Obrigações do governo",
                "municipalBonds": "Obrigações municipais",
                "strategiesSpreads": "Estratégias e Spreads",
                "unspecifiedBonds": "Obrigações não especificadas",
                "unspecifiedFundsCertificates": "Fundos e certificados não especificados",
                "warrants": "Warrants",
                "forex": "Forex",
                "startDate": "Start Date",
                "earliest": "Earliest",
                "common": "Common",
                "mainTicker": "Main Ticker",
                "startDateIllustrate": "Indicate the base date when comparison added"
            },
            'zh': {
                "invalidInputDefault": "请输入一个正整数，或不输入。",
                "invalidInputNpi": "请输入一个正整数。",
                "frequency": "频率",
                "dataRange": "日期区间",
                "customDate": "定制日期",
                "customStartDate": "开始日期",
                "customEndDate": "结束日期",
                "labelSearch": "添加资产比较",
                'labelChange': '更换资产',
                "eventsIndicators": "事件和指数",
                "events": "事件",
                "eventsDividende": "股息",
                "eventsSplits": "分割",
                "eventsEarnings": "收益",
                "indicators": "指数",
                "indicatorsSMA": "简单移动平均(SMA)",
                "indicatorsSMAlabel1": "1线时间范围",
                "indicatorsSMAlabel2": "2线时间范围",
                "indicatorsSMAlabel3": "3线时间范围",
                "indicatorsEMA": "指数移动平均(EMA)",
                "indicatorsEMAlabel1": "1线时间范围",
                "indicatorsEMAlabel2": "2线时间范围",
                "indicatorsEMAlabel3": "3线时间范围",
                "indicatorsVolume": "交易量",
                "indicatorsVolumeSMA": "交易量简单移动平均线",
                "indicatorsPeriod": "时段",
                "indicatorsBBands": "布林带",
                "indicatorsBBandsPeriod": "时段",
                "indicatorsBBandsDeviation": "标准差",
                "indicatorsPSAR": "抛物线停损转向指标(PSAR)",
                "indicatorsPSARStep": "Step时段",
                "indicatorsPSARMaxStep": "Max Step范围",
                "indicatorsMACD": "MACD",
                "indicatorsMACDSlow": "慢速时段",
                "indicatorsMACDFast": "快速时段",
                "indicatorsMACDSignal": "指标时段",
                "indicatorsRSI": "相对强弱指数(RSI)",
                "indicatorsRSIPeriod": "时段",
                "indicatorsROC": "变动率",
                "indicatorsROCPeriod": "时段",
                'indicatorsCCI': '顺势指标(CCI)',
                'indicatorsCCIPeriod': '时段',
                "indicatorsSMAR": "Williams %R",
                "indicatorsSMAPeriod": "时段",
                "indicatorsSMASlow": "慢速随机指标",
                "indicatorsSMAK": "K % 时段",
                "indicatorsSMAD": "D % 时段",
                "indicatorsSMAFast": "快速随机指标",
                "indicatorsSMAFastK": "K % 时段",
                "indicatorsSMAFastD": "D % 时段",
                "indicatorsSMAPrice": "价格通道",
                "indicatorsSMAPriceChannel": "价格通道",
                "indicatorsSMAMA": "移动平均线轨道",
                "indicatorsSMAMAPeriod": "时段",
                "indicatorsSMAMABand": "频宽",
                "indicatorsSMAMomentum": "动量指标",
                "indicatorsSMAMomentumPeriod": "时段",
                "indicatorsSMAULT": "终极震荡(ULT)指标",
                "indicatorsSMADMI": "动向指数(DMI)",
                "indicatorsSMADMIPeriod": "时段",
                "indicatorsSMAMoney": "金钱流指标",
                "indicatorsSMAMoneyPeriod": "时段",
                "indicatorsSMAOBV": "能量潮指标",
                "indicatorsEMAVol": "累积交易量",
                "indicatorsEMADirect": "涨跌比率",
                "indicatorsEMADirectPeriodo": "时段",
                "indicatorsEMADirectSmoothing": "平滑法",
                "indicatorsEMAVolume": "股价成交量分布",
                "indicatorsEMAFast": "快速波动指标",
                "indicatorsEMAWeight": "加权移动平均数",
                "indicatorsEMAWeightPeriodo": "时段",
                "indicatorsEMAAD": "累积/卖出",
                "indicatorsEMAMass": "梅斯线",
                "indicatorsEMAVolat": "波动率",
                "indicatorsEMAVolatPeriod": "时段",
                "indicatorsEMAVolatPeriodA": "上期时段",
                "indicatorsEMAForce": "强力指数",
                "indicatorsEMAForcePeriod": "时段",
                "indicatorsEMARange": "高于真正范围",
                "indicatorsVolumeKeltner": "凯勒Kelter指数",
                "indicatorsVolumeKeltnerEMA": "EMA 时段",
                "indicatorsVolumeKeltnerTimes": "时间",
                "indicatorsVolumeKeltnerATR": "ATR 时段",
                "indicatorsVolumePrevious": "上次收盘线",
                "performanceGrowthChart": "业绩增长图",
                "pricesGrowthChart": "价格增长图",
                "performanceGrowthChartance": "业绩",
                "update": "更新",
                "fundamentals": "基本分析",
                "priceEarnings": "本益比",
                "priceSales": "股价营收比",
                "priceBook": "市帐率",
                "priceCash": "股价现金比",
                "fairValue": "公允价值",
                "rollingDividend": "滚动股息",
                "dividendYield": "股息率",
                "rollingEPS": "滚动每股收益",
                "drawings": "绘图",
                "trendLine": "趋势线",
                "rectangle": "方形",
                "ellipse": "椭圆形",
                "levelLine": "平行线",
                "fibonacciRL": "费氏指数",
                "fibonacciFans": "Fibonacci Fans",
                "fibonacciTZ": "费氏时间周期",
                "fibonacciArcs": "费氏弧线",
                "shortInt": "卖空比率",
                "priceEarnings0": "Discount Cum Fair",
                "priceEarnings1": "净资产",
                "priceEarnings2": "溢价/折价",
                "display": "显示",
                "cursorType": "游标类型",
                "crosshair": "十字",
                "trackBall": "球状",
                "off": "关闭",
                "chartType": "图表类别",
                "mountain": "山状图",
                "line": "线状",
                "dot": "点状图",
                "aboveBelow": "高于/低于",
                "OHLC": "OHLC",
                "HLC": "HLC",
                "candlestick": "K 线图",
                "growth": "成长百分比",
                "10KGrowth": "一万元回报",
                "priceWithDividendGrowth": "计算股息的价格",
                "dividendEffect": "股息影响",
                "postTax": "税后收益",
                "yAxis": "Y-轴",
                "left": "左",
                "right": "右",
                "verticalScale": "直比例",
                "linear": "线性",
                "logarithmic": "对数",
                "selectionMode": "选择模式",
                "pan": "Pan",
                "zoomIn": "放大",
                "reset": "重设",
                "other": "其他",
                "extendedMarketHour": "扩展的市场时间",
                "volumePlus": "交易量+",
                'oneMinute': '1 分钟',
                'fiveMinute': "5 分钟",
                'tenMinute': "10 分钟",
                'fifteenMinute': "15 分钟",
                'thirtyMinute': "30 分钟",
                'sixtyMinute': "60 分钟",
                'daily': "每日",
                'weekly': "每周",
                'monthly': "每月",
                "date": "日期",
                "time": "时间",
                "nav": "净资产",
                'oneMinuteValueChange': '1 分钟 涨跌',
                'oneMinuteValueChangePercent': '1 分钟 % 涨跌幅度',
                'fiveMinuteValueChange': "5 分钟 涨跌",
                'fiveMinuteValueChangePercent': "5 分钟 % 涨跌幅度",
                'tenMinuteValueChange': "10 分钟 涨跌",
                'tenMinuteValueChangePercent': "10 分钟 % 涨跌幅度",
                'fifteenMinuteValueChange': "15 分钟 涨跌",
                'fifteenMinuteValueChangePercent': "15 分钟 % 涨跌幅度",
                'thirtyMinuteValueChange': "30 分钟 涨跌",
                'thirtyMinuteValueChangePercent': "30 分钟 % 涨跌幅度",
                'sixtyMinuteValueChange': "60 分钟 涨跌",
                'sixtyMinuteValueChangePercent': "60 分钟 % 涨跌幅度",
                'dailyValueChange': "每日 涨跌",
                'dailyValueChangePercent': "每日 % 涨跌幅度",
                'weeklyValueChange': "每周 涨跌",
                'weeklyValueChangePercent': "每周 % 涨跌幅度",
                'monthlyValueChange': "每月 涨跌",
                'monthlyValueChangePercent': "每月 % 涨跌幅度",
                "totalReturn": "总收益",
                "marketValue": "市场价值",
                "open": "开盘",
                "close": "收盘",
                "low": "低",
                "high": "高",
                "volume": "交易量",
                "value": "价值",
                "semiAnnual": "半年",
                "annual": "年度",
                "quarterly": "季度",
                "mainGrowthLabel": "基金业绩",
                "compareGrowthLabel": "业绩基准",
                "closeDateLabel": "市场结束日期",
                "range": "范围",
                "datanotavailable": "资料不可用。",
                "mifidRuleMessage": "该图表和相关数据将在基金成立之日起{0}个月后提供",
                "changetodailyfrequency": "这是一个每日数据点。请将频率改成每日。",
                "tenKGrowth": "一万元回报",
                "postTax": "税后收益",
                "addComparison": "添加比较",
                "changeTicker": "'更换",
                "searchAssets": "搜索资产",
                "crosshairsPopoverNoData": "--",
                "mainChartHeaderDividendEffectLabel": "（有红利）",
                "compareChartsMaxAllowedErrorLabel": "已达到最多比较添加。",
                "oneDay": "1天",
                "fiveDay": "5天",
                "fifteenDay": "15天",
                "oneMonth": "1个月",
                "threeMonth": "3个月",
                "sixMonth": "6个月",
                "YTD": "今年",
                "oneYear": "1年",
                "threeYear": "3年",
                "fiveYear": "5年",
                "tenYear": "10年",
                "max": "最大",
                "to": "到",
                "frequencys": "频率",
                "dividendText": "D",
                "splitText": "S",
                "earningText": "E",
                "settings": "设定",
                "optionsBtnText": "选项",
                "export": "导出",
                "print": "打印",
                "closeBtnText": "关闭",
                "errorsMsg": "您的移动设备不能显示某些图表信息。请从平板或电脑登录，以获得更佳交易体验。",
                'fundSize': '基金规模',
                'price': '价格',
                'shareholdersNumber': '股东人数',
                'name': '名字',
                'PE': '本益比',
                'PS': '股价营收比',
                'PB': '市帐率',
                'PC': '股价现金比',
                'FairValue': 'Fair Value',
                'RDividend': '滚动股息',
                'DYield': '股息率',
                'REPS': '滚动每股收益',
                'PremiumDiscount': '溢价/折价',
                'DiscountCumFair': 'Discount Cum Fair',
                'SInterest': '卖空比率',
                'SMA': 'SMA',
                'EMA': 'EMA',
                'SMAV': 'SMAV',
                'BBands': 'BBands',
                'PSAR': 'PSAR',
                'RSI': '相对强弱指数(RSI)',
                'ROC': '变动率',
                'CCI': 'CCI',
                'WillR': 'WillR',
                'SStochastic': '慢速随机指标',
                'FStochastic': '快速随机指标',
                'PChannel': '价格通道',
                'MAE': '移动平均线轨道',
                'Momentum': '动量指标',
                'ULT': '终极震荡(ULT)指标',
                'MFI': '金钱流指标',
                'OBV': '能量潮指标',
                'VAcc': '累积交易量',
                'UDRatio': '涨跌比率',
                'FVolatility': '快速波动指标',
                'WMA': '加权移动平均数',
                'AccDis': '累积/卖出',
                'Mass': '梅斯线',
                'Volatility': '波动率',
                'ForceIndex': '强力指数',
                'ATR': '高于真正范围',
                'Keltner': 'Kelter指数',
                'VBP': 'VBP',
                'DMI': ['DMI+', ' DMI-', ' ADX'],
                'MACD': ['MACD', 'EMA', 'Divergence'],
                'PrevClose': '昨日收盘',
                "mutualFund": "共同基金",
                "closedEndFund": "封闭式基金",
                "equities": "股票",
                "index": "指数",
                "eTF": "交易所基金",
                "commonStocks": "普通股",
                "preferredStocks": "优先股",
                "aDRs": "ADRs",
                "options": "期权",
                "futures": "期货",
                "debenture": "债券",
                "governmentBonds": "政府债券",
                "municipalBonds": "市政债券",
                "strategiesSpreads": "策略与传播",
                "unspecifiedBonds": "未指定债券",
                "unspecifiedFundsCertificates": "未指定的资金和证书",
                "warrants": "认股权证",
                "forex": "外汇",
                "startDate": "开始日期",
                "earliest": "最早",
                "common": "共同时期",
                "mainTicker": "主要Ticker",
                "startDateIllustrate": "当加入比较的Ticker时的开始比较时间"
            },
            'zh-TW': {
                "invalidInputDefault": "請輸入一個正整數，或不輸入。",
                "invalidInputNpi": "請輸入一個正整數。",
                "frequency": "頻率",
                "dataRange": "日期區間",
                "customDate": "定制日期",
                "customStartDate": "開始日期",
                "customEndDate": "結束日期",
                "labelSearch": "添加資產比較",
                'labelChange': '更换資產',
                "eventsIndicators": "事件和指數",
                "events": "事件",
                "eventsDividende": "股息",
                "eventsSplits": "分割",
                "eventsEarnings": "收益",
                "indicators": "指數",
                "indicatorsSMA": "簡單移動平均(SMA)",
                "indicatorsSMAlabel1": "1線時間範圍",
                "indicatorsSMAlabel2": "2線時間範圍",
                "indicatorsSMAlabel3": "3線時間範圍",
                "indicatorsEMA": "指數移動平均(EMA)",
                "indicatorsEMAlabel1": "1線時間範圍",
                "indicatorsEMAlabel2": "2線時間範圍",
                "indicatorsEMAlabel3": "3線時間範圍",
                "indicatorsVolume": "交易量",
                "indicatorsVolumeSMA": "交易量簡單移動平均線",
                "indicatorsPeriod": "時段",
                "indicatorsBBands": "布林带",
                "indicatorsBBandsPeriod": "時段",
                "indicatorsBBandsDeviation": "標準差",
                "indicatorsPSAR": "拋物線停損轉向指標(PSAR)",
                "indicatorsPSARStep": "Step時段",
                "indicatorsPSARMaxStep": "Max Step範圍",
                "indicatorsMACD": "MACD",
                "indicatorsMACDSlow": "慢速時段",
                "indicatorsMACDFast": "快速時段",
                "indicatorsMACDSignal": "指標時段",
                "indicatorsRSI": "相對強弱指數(RSI)",
                "indicatorsRSIPeriod": "時段",
                "indicatorsROC": "變動率",
                "indicatorsROCPeriod": "時段",

                "indicatorsSMAR": "Williams %R",
                "indicatorsSMAPeriod": "時段",
                "indicatorsSMASlow": "慢速隨機指標",
                "indicatorsSMAK": "K % 時段",
                "indicatorsSMAD": "D % 時段",
                "indicatorsSMAFast": "快速隨機指標",
                "indicatorsSMAFastK": "K % 時段",
                "indicatorsSMAFastD": "D % 時段",
                "indicatorsSMAPrice": "價格通道",
                "indicatorsSMAPriceChannel": "價格通道",
                "indicatorsSMAMA": "移動平均線軌道",
                "indicatorsSMAMAPeriod": "時段",
                "indicatorsSMAMABand": "頻寬",
                "indicatorsSMAMomentum": "動量指標",
                "indicatorsSMAMomentumPeriod": "時段",
                "indicatorsSMAULT": "終極震盪(ULT)指標",
                "indicatorsSMADMI": "動向指數(DMI)",
                "indicatorsSMADMIPeriod": "時段",
                "indicatorsSMAMoney": "金錢流指標",
                "indicatorsSMAMoneyPeriod": "時段",
                "indicatorsSMAOBV": "能量潮指標",
                "indicatorsEMAVol": "累積交易量",
                "indicatorsEMADirect": "漲跌比率",
                "indicatorsEMADirectPeriodo": "時段",
                "indicatorsEMADirectSmoothing": "平滑法",
                "indicatorsEMAVolume": "股價成交量分佈",
                "indicatorsEMAFast": "快速波動指標",
                "indicatorsEMAWeight": "加權移動平均數",
                "indicatorsEMAWeightPeriodo": "時段",
                "indicatorsEMAAD": "累積/賣出",
                "indicatorsEMAMass": "梅斯線",
                "indicatorsEMAVolat": "波動率",
                "indicatorsEMAVolatPeriod": "時段",
                "indicatorsEMAVolatPeriodA": "上期時段",
                "indicatorsEMAForce": "強力指數",
                "indicatorsEMAForcePeriod": "時段",
                "indicatorsEMARange": "高於真正範圍",
                "indicatorsVolumeKeltner": "凱勒Kelter指數",
                "indicatorsVolumeKeltnerEMA": "EMA 時段",
                "indicatorsVolumeKeltnerTimes": "時間",
                "indicatorsVolumeKeltnerATR": "ATR 時段",
                "indicatorsVolumePrevious": "上次收盤線",
                "performanceGrowthChart": "業績增長圖",
                "pricesGrowthChart": "價格增長圖",
                "performanceGrowthChartance": "業績",
                "update": "更新",
                "fundamentals": "基本面",
                "priceEarnings": "本益比",
                "priceSales": "股價營收比",
                "priceBook": "市帳率",
                "priceCash": "股價現金比",
                "fairValue": "公允價值",
                "rollingDividend": "滾動股息",
                "dividendYield": "股息率",
                "rollingEPS": "滾動每股收益",
                "drawings": "繪圖",
                "trendLine": "趨勢線",
                "rectangle": "方形",
                "ellipse": "橢圓形",
                "levelLine": "平行線",
                "fibonacciRL": "費氏指數",
                "fibonacciFans": "Fibonacci Fans",
                "fibonacciTZ": "費氏時間週期",
                "fibonacciArcs": "費氏弧線",
                "shortInt": "賣空比率",
                "priceEarnings0": "Discount Cum Fair",
                "priceEarnings1": "淨資產",
                "priceEarnings2": "溢價/折價",
                "display": "顯示",
                "cursorType": "游標類型",
                "crosshair": "十字",
                "trackBall": "球狀",
                "off": "關閉",
                "chartType": "圖表類別",
                "mountain": "山狀圖",
                "line": "線狀",
                "dot": "點狀圖",
                "aboveBelow": "高於/低於",
                "OHLC": "OHLC",
                "HLC": "HLC",
                "candlestick": "K 缐圖",
                "growth": "成長百分比",
                "10KGrowth": "一萬元回報",
                "priceWithDividendGrowth": "計算股息增長的價格",
                "dividendEffect": "股息影響",
                "postTax": "稅後收益",
                "yAxis": "Y-軸",
                "left": "左",
                "right": "右",
                "verticalScale": "直比例",
                "linear": "線性",
                "logarithmic": "對數",
                "selectionMode": "選擇模式",
                "pan": "Pan",
                "zoomIn": "放大",
                "reset": "重設",
                "other": "其他",
                "extendedMarketHour": "扩展的市场时间",
                "volumePlus": "交易量+",
                'oneMinute': '1 分鐘',
                'fiveMinute': "5 分鐘",
                'tenMinute': "10 分鐘",
                'fifteenMinute': "15 分鐘",
                'thirtyMinute': "30 分鐘",
                'sixtyMinute': "60 分鐘",
                'daily': "每日",
                'weekly': "每週",
                'monthly': "每月",
                "date": "日期",
                "time": "時間",
                "nav": "淨資產",
                'oneMinuteValueChange': '1 min 漲跌',
                'oneMinuteValueChangePercent': '1 min % 漲跌幅度',
                'fiveMinuteValueChange': "5 min 漲跌",
                'fiveMinuteValueChangePercent': "5 min % 漲跌幅度",
                'tenMinuteValueChange': "10 min 漲跌",
                'tenMinuteValueChangePercent': "10 min % 漲跌幅度",
                'fifteenMinuteValueChange': "15 min 漲跌",
                'fifteenMinuteValueChangePercent': "15 min % 漲跌幅度",
                'thirtyMinuteValueChange': "30 min 漲跌",
                'thirtyMinuteValueChangePercent': "30 min % 漲跌幅度",
                'sixtyMinuteValueChange': "60 min 漲跌",
                'sixtyMinuteValueChangePercent': "60 min % 漲跌幅度",
                'dailyValueChange': "每日 漲跌",
                'dailyValueChangePercent': "每日 % 漲跌幅度",
                'weeklyValueChange': "每週 漲跌",
                'weeklyValueChangePercent': "每週 % 漲跌幅度",
                'monthlyValueChange': "每月 漲跌",
                'monthlyValueChangePercent': "每月 % 漲跌幅度",
                "totalReturn": "总收益",
                "marketValue": "市场价值",
                "open": "開盤",
                "close": "關盤",
                "low": "低",
                "high": "高",
                "volume": "交易量",
                "value": "價值",
                "semiAnnual": "半年",
                "annual": "年度",
                "quarterly": "季度",
                "mainGrowthLabel": "基金業績",
                "compareGrowthLabel": "業績基準",
                "closeDateLabel": "市場結束日期",
                "range": "範圍",
                "datanotavailable": "資料不可用。",
                "mifidRuleMessage": "該圖表和相關數據將在基金成立之日起{0}個月後提供",
                "changetodailyfrequency": "這是一個每日資料點。 請將頻率改成每日。",
                "tenKGrowth": "一萬元回報",
                "postTax": "稅後收益",
                "addComparison": "添加比較",
                "changeTicker": "'更换",
                "searchAssets": "搜索資產",
                "crosshairsPopoverNoData": "--",
                "mainChartHeaderDividendEffectLabel": "（有紅利）",
                "compareChartsMaxAllowedErrorLabel": "已達到最多比較添加。",
                "oneDay": "1 天",
                "fiveDay": "5 天",
                "fifteenDay": "15 天",
                "oneMonth": "1 個月",
                "threeMonth": "3 個月",
                "sixMonth": "6 個月",
                "YTD": "今年",
                "oneYear": "1 年",
                "threeYear": "3 年",
                "fiveYear": "5 年",
                "tenYear": "10 年",
                "max": "最大",
                "to": "到",
                "frequencys": "頻率",
                "dividendText": "D",
                "splitText": "S",
                "earningText": "E",
                "settings": "設定",
                "optionsBtnText": "選項",
                "export": "匯出",
                "print": "打印",
                "closeBtnText": "關閉",
                "errorsMsg": "您的行動裝置不能顯示某些圖表資訊。 請從平板或電腦登錄，以獲得更佳交易體驗。",
                'fundSize': '基金規模',
                'price': '价格',
                'shareholdersNumber': '股東人數',
                'name': '名稱',
                'PE': '本益比',
                'PS': '股價營收比',
                'PB': '市帳率',
                'PC': '股價現金比',
                'FairValue': 'Fair Value',
                'RDividend': '滾動股息',
                'DYield': '股息率',
                'REPS': '滾動每股收益',
                'PremiumDiscount': '溢價/折價',
                'DiscountCumFair': 'Discount Cum Fair',
                'SInterest': '賣空比率',
                'SMA': 'SMA',
                'EMA': 'EMA',
                'SMAV': 'SMAV',
                'BBands': '布林带',
                'PSAR': 'PSAR',
                'RSI': '相對強弱指數(RSI)',
                'ROC': '變動率',
                'CCI': 'CCI',
                'WillR': 'WillR',
                'SStochastic': '慢速隨機指標',
                'FStochastic': '快速隨機指標',
                'PChannel': '價格通道',
                'MAE': '移動平均線軌道',
                'Momentum': '動量指標',
                'ULT': '終極震盪(ULT)指標',
                'MFI': '金錢流指標',
                'OBV': '能量潮指標',
                'VAcc': '累積交易量',
                'UDRatio': '漲跌比率',
                'FVolatility': '快速波動指標',
                'WMA': '加權移動平均數',
                'AccDis': '累積/賣出',
                'Mass': '梅斯線',
                'Volatility': '波動率',
                'ForceIndex': '強力指數',
                'ATR': '高於真正範圍',
                'Keltner': 'Keltner指數',
                'VBP': 'VBP',
                'DMI': ['DMI+', ' DMI-', ' ADX'],
                'MACD': ['MACD', 'EMA', 'Divergence'],
                'PrevClose': '昨日收盤',
                "mutualFund": "共同基金",
                "closedEndFund": "封閉式基金",
                "equities": "股票",
                "index": "指數",
                "eTF": "交易所交易基金",
                "commonStocks": "普通股",
                "preferredStocks": "優先股",
                "aDRs": "ADRs",
                "options": "期權",
                "futures": "期貨",
                "debenture": "債券",
                "governmentBonds": "政府債券",
                "municipalBonds": "市政債券",
                "strategiesSpreads": "策略與傳播",
                "unspecifiedBonds": "未指定債券",
                "unspecifiedFundsCertificates": "未指定的資金和證書",
                "warrants": "認股權證",
                "forex": "外匯",
                "startDate": "开始日期",
                "earliest": "最早",
                "common": "共同時期",
                "mainTicker": "主要Ticker",
                "startDateIllustrate": "加入比較ticker時比較的開始時間"
            },
            'zh-HK': {
                "invalidInputDefault": "請輸入一個正整數，或不輸入。",
                "invalidInputNpi": "請輸入一個正整數。",
                "frequency": "頻率",
                "dataRange": "日期區間",
                "customDate": "定制日期",
                "customStartDate": "開始日期",
                "customEndDate": "結束日期",
                "labelSearch": "添加資產比較",
                'labelChange': '更换資產',
                "eventsIndicators": "事件和指數",
                "events": "事件",
                "eventsDividende": "股息",
                "eventsSplits": "分割",
                "eventsEarnings": "收益",
                "indicators": "指數",
                "indicatorsSMA": "簡單移動平均(SMA)",
                "indicatorsSMAlabel1": "1線時間範圍",
                "indicatorsSMAlabel2": "2線時間範圍",
                "indicatorsSMAlabel3": "3線時間範圍",
                "indicatorsEMA": "指數移動平均(EMA)",
                "indicatorsEMAlabel1": "1線時間範圍",
                "indicatorsEMAlabel2": "2線時間範圍",
                "indicatorsEMAlabel3": "3線時間範圍",
                "indicatorsVolume": "交易量",
                "indicatorsVolumeSMA": "交易量簡單移動平均線",
                "indicatorsPeriod": "時段",
                "indicatorsBBands": "布林带",
                "indicatorsBBandsPeriod": "時段",
                "indicatorsBBandsDeviation": "標準差",
                "indicatorsPSAR": "拋物線停損轉向指標(PSAR)",
                "indicatorsPSARStep": "Step時段",
                "indicatorsPSARMaxStep": "Max Step範圍",
                "indicatorsMACD": "MACD",
                "indicatorsMACDSlow": "慢速時段",
                "indicatorsMACDFast": "快速時段",
                "indicatorsMACDSignal": "指標時段",
                "indicatorsRSI": "相對強弱指數(RSI)",
                "indicatorsRSIPeriod": "時段",
                "indicatorsROC": "變動率",
                "indicatorsROCPeriod": "時段",
                'indicatorsCCI': '順勢指標(CCI)',
                'indicatorsCCIPeriod': '時段',
                "indicatorsSMAR": "Williams %R",
                "indicatorsSMAPeriod": "時段",
                "indicatorsSMASlow": "慢速隨機指標",
                "indicatorsSMAK": "K % 時段",
                "indicatorsSMAD": "D % 時段",
                "indicatorsSMAFast": "快速隨機指標",
                "indicatorsSMAFastK": "K % 時段",
                "indicatorsSMAFastD": "D % 時段",
                "indicatorsSMAPrice": "價格通道",
                "indicatorsSMAPriceChannel": "價格通道",
                "indicatorsSMAMA": "移動平均線軌道",
                "indicatorsSMAMAPeriod": "時段",
                "indicatorsSMAMABand": "頻寬",
                "indicatorsSMAMomentum": "動量指標",
                "indicatorsSMAMomentumPeriod": "時段",
                "indicatorsSMAULT": "終極震盪(ULT)指標",
                "indicatorsSMADMI": "動向指數(DMI)",
                "indicatorsSMADMIPeriod": "時段",
                "indicatorsSMAMoney": "金錢流指標",
                "indicatorsSMAMoneyPeriod": "時段",
                "indicatorsSMAOBV": "能量潮指標",
                "indicatorsEMAVol": "累積交易量",
                "indicatorsEMADirect": "漲跌比率",
                "indicatorsEMADirectPeriodo": "時段",
                "indicatorsEMADirectSmoothing": "平滑法",
                "indicatorsEMAVolume": "股價成交量分佈",
                "indicatorsEMAFast": "快速波動指標",
                "indicatorsEMAWeight": "加權移動平均數",
                "indicatorsEMAWeightPeriodo": "時段",
                "indicatorsEMAAD": "累積/賣出",
                "indicatorsEMAMass": "梅斯線",
                "indicatorsEMAVolat": "波動率",
                "indicatorsEMAVolatPeriod": "時段",
                "indicatorsEMAVolatPeriodA": "上期時段",
                "indicatorsEMAForce": "強力指數",
                "indicatorsEMAForcePeriod": "時段",
                "indicatorsEMARange": "高於真正範圍",
                "indicatorsVolumeKeltner": "凱勒Kelter指數",
                "indicatorsVolumeKeltnerEMA": "EMA 時段",
                "indicatorsVolumeKeltnerTimes": "時間",
                "indicatorsVolumeKeltnerATR": "ATR 時段",
                "indicatorsVolumePrevious": "上次收盤線",
                "performanceGrowthChart": "業績增長圖",
                "pricesGrowthChart": "價格增長圖",
                "performanceGrowthChartance": "業績",
                "update": "更新",
                "fundamentals": "基本面",
                "priceEarnings": "本益比",
                "priceSales": "股價營收比",
                "priceBook": "市帳率",
                "priceCash": "股價現金比",
                "fairValue": "公允價值",
                "rollingDividend": "滾動股息",
                "dividendYield": "股息率",
                "rollingEPS": "滾動每股收益",
                "drawings": "繪圖",
                "trendLine": "趨勢線",
                "rectangle": "方形",
                "ellipse": "橢圓形",
                "levelLine": "平行線",
                "fibonacciRL": "費氏指數",
                "fibonacciFans": "Fibonacci Fans",
                "fibonacciTZ": "費氏時間週期",
                "fibonacciArcs": "費氏弧線",
                "shortInt": "賣空比率",
                "priceEarnings0": "Discount Cum Fair",
                "priceEarnings1": "淨資產",
                "priceEarnings2": "溢價/折價",
                "display": "顯示",
                "cursorType": "游標類型",
                "crosshair": "十字",
                "trackBall": "球狀",
                "off": "關閉",
                "chartType": "圖表類別",
                "mountain": "山狀圖",
                "line": "線狀",
                "dot": "點狀圖",
                "aboveBelow": "高於/低於",
                "OHLC": "OHLC",
                "HLC": "HLC",
                "candlestick": "K 缐圖",
                "growth": "成長百分比",
                "10KGrowth": "一萬元回報",
                "priceWithDividendGrowth": "計算股息增長的價格",
                "dividendEffect": "股息影響",
                "postTax": "稅後收益",
                "yAxis": "Y-軸",
                "left": "左",
                "right": "右",
                "verticalScale": "直比例",
                "linear": "線性",
                "logarithmic": "對數",
                "selectionMode": "選擇模式",
                "pan": "Pan",
                "zoomIn": "放大",
                "reset": "重設",
                "other": "其他",
                "extendedMarketHour": "扩展的市场时间",
                "volumePlus": "交易量+",
                'oneMinute': '1 分鐘',
                'fiveMinute': "5 分鐘",
                'tenMinute': "10 分鐘",
                'fifteenMinute': "15 分鐘",
                'thirtyMinute': "30 分鐘",
                'sixtyMinute': "60 分鐘",
                'daily': "每日",
                'weekly': "每週",
                'monthly': "每月",
                "date": "日期",
                "time": "時間",
                "nav": "淨資產",
                'oneMinuteValueChange': '1 min 漲跌',
                'oneMinuteValueChangePercent': '1 min % 漲跌幅度',
                'fiveMinuteValueChange': "5 min 漲跌",
                'fiveMinuteValueChangePercent': "5 min % 漲跌幅度",
                'tenMinuteValueChange': "10 min 漲跌",
                'tenMinuteValueChangePercent': "10 min % 漲跌幅度",
                'fifteenMinuteValueChange': "15 min 漲跌",
                'fifteenMinuteValueChangePercent': "15 min % 漲跌幅度",
                'thirtyMinuteValueChange': "30 min 漲跌",
                'thirtyMinuteValueChangePercent': "30 min % 漲跌幅度",
                'sixtyMinuteValueChange': "60 min 漲跌",
                'sixtyMinuteValueChangePercent': "60 min % 漲跌幅度",
                'dailyValueChange': "每日 漲跌",
                'dailyValueChangePercent': "每日 % 漲跌幅度",
                'weeklyValueChange': "每週 漲跌",
                'weeklyValueChangePercent': "每週 % 漲跌幅度",
                'monthlyValueChange': "每月 漲跌",
                'monthlyValueChangePercent': "每月 % 漲跌幅度",
                "totalReturn": "总收益",
                "marketValue": "市场价值",
                "open": "開盤",
                "close": "關盤",
                "low": "低",
                "high": "高",
                "volume": "交易量",
                "value": "價值",
                "semiAnnual": "半年",
                "annual": "年度",
                "quarterly": "季度",
                "mainGrowthLabel": "基金業績",
                "compareGrowthLabel": "業績基準",
                "closeDateLabel": "市場結束日期",
                "range": "範圍",
                "datanotavailable": "資料不可用。",
                "mifidRuleMessage": "該圖表和相關數據將在基金成立之日起{0}個月後提供",
                "changetodailyfrequency": "這是一個每日資料點。 請將頻率改成每日。",
                "tenKGrowth": "一萬元回報",
                "postTax": "稅後收益",
                "addComparison": "添加比較",
                "changeTicker": "'更换",
                "searchAssets": "搜索資產",
                "crosshairsPopoverNoData": "--",
                "mainChartHeaderDividendEffectLabel": "（有紅利）",
                "compareChartsMaxAllowedErrorLabel": "已達到最多比較添加。",
                "oneDay": "1 天",
                "fiveDay": "5 天",
                "fifteenDay": "15 天",
                "oneMonth": "1 個月",
                "threeMonth": "3 個月",
                "sixMonth": "6 個月",
                "YTD": "今年",
                "oneYear": "1 年",
                "threeYear": "3 年",
                "fiveYear": "5 年",
                "tenYear": "10 年",
                "max": "最大",
                "to": "到",
                "frequencys": "頻率",
                "dividendText": "D",
                "splitText": "S",
                "earningText": "E",
                "settings": "設定",
                "optionsBtnText": "選項",
                "export": "匯出",
                "print": "打印",
                "closeBtnText": "關閉",
                "errorsMsg": "您的行動裝置不能顯示某些圖表資訊。 請從平板或電腦登錄，以獲得更佳交易體驗。",
                'fundSize': '基金規模',
                'price': '价格',
                'shareholdersNumber': '股東人數',
                'name': '名稱',
                'PE': '本益比',
                'PS': '股價營收比',
                'PB': '市帳率',
                'PC': '股價現金比',
                'FairValue': 'Fair Value',
                'RDividend': '滾動股息',
                'DYield': '股息率',
                'REPS': '滾動每股收益',
                'PremiumDiscount': '溢價/折價',
                'DiscountCumFair': 'Discount Cum Fair',
                'SInterest': '賣空比率',
                'SMA': 'SMA',
                'EMA': 'EMA',
                'SMAV': 'SMAV',
                'BBands': '布林带',
                'PSAR': 'PSAR',
                'RSI': '相對強弱指數(RSI)',
                'ROC': '變動率',
                'CCI': 'CCI',
                'WillR': 'WillR',
                'SStochastic': '慢速隨機指標',
                'FStochastic': '快速隨機指標',
                'PChannel': '價格通道',
                'MAE': '移動平均線軌道',
                'Momentum': '動量指標',
                'ULT': '終極震盪(ULT)指標',
                'MFI': '金錢流指標',
                'OBV': '能量潮指標',
                'VAcc': '累積交易量',
                'UDRatio': '漲跌比率',
                'FVolatility': '快速波動指標',
                'WMA': '加權移動平均數',
                'AccDis': '累積/賣出',
                'Mass': '梅斯線',
                'Volatility': '波動率',
                'ForceIndex': '強力指數',
                'ATR': '高於真正範圍',
                'Keltner': 'Keltner指數',
                'VBP': 'VBP',
                'DMI': ['DMI+', ' DMI-', ' ADX'],
                'MACD': ['MACD', 'EMA', 'Divergence'],
                'PrevClose': '昨日收盤',
                "mutualFund": "共同基金",
                "closedEndFund": "封閉式基金",
                "equities": "股票",
                "index": "指數",
                "eTF": "交易所交易基金",
                "commonStocks": "普通股",
                "preferredStocks": "優先股",
                "aDRs": "ADRs",
                "options": "期權",
                "futures": "期貨",
                "debenture": "債券",
                "governmentBonds": "政府債券",
                "municipalBonds": "市政債券",
                "strategiesSpreads": "策略與傳播",
                "unspecifiedBonds": "未指定債券",
                "unspecifiedFundsCertificates": "未指定的資金和證書",
                "warrants": "認股權證",
                "forex": "外匯",
                "startDate": "开始日期",
                "earliest": "最早",
                "common": "共同時期",
                "mainTicker": "主要Ticker",
                "startDateIllustrate": "加入比較ticker時比較的開始時間"
            },
            'ja': {
                "invalidInputDefault": "正の値を入力するか何も入力しないでください。",
                "invalidInputNpi": "正の値を入力してください。",
                "frequency": "頻度",
                "dataRange": "データ期間",
                "customDate": "任意設定",
                "customStartDate": "開始日",
                "customEndDate": "終了日",
                "labelSearch": "比較対象を追加",
                "eventsIndicators": "イベントと指標",
                "events": "イベント",
                "eventsDividende": "配当・分配金",
                "eventsSplits": "分割",
                "eventsEarnings": "決算（利益）",
                "indicators": "指標",
                "indicatorsSMA": "単純移動平均線 (SMA)",
                "indicatorsSMAlabel1": "線1 期間",
                "indicatorsSMAlabel2": "線2 期間",
                "indicatorsSMAlabel3": "線3 期間",
                "indicatorsEMA": "指数平滑移動平均線 (EMA)",
                "indicatorsEMAlabel1": "線1 期間",
                "indicatorsEMAlabel2": "線2 期間",
                "indicatorsEMAlabel3": "線3 期間",
                "indicatorsVolume": "出来高",
                "indicatorsVolumeSMA": "出来高 SMA",
                "indicatorsPeriod": "期間",
                "indicatorsBBands": "ボリンジャー・バンド (BB)",
                "indicatorsBBandsPeriod": "期間",
                "indicatorsBBandsDeviation": "標準偏差",
                "indicatorsPSAR": "パラボリックSAR (PSAR)",
                "indicatorsPSARStep": "加速因数",
                "indicatorsPSARMaxStep": "最大加速因数",
                "indicatorsMACD": "MACD",
                "indicatorsMACDSlow": "長期期間",
                "indicatorsMACDFast": "短期期間",
                "indicatorsMACDSignal": "シグナル期間",
                "indicatorsRSI": "相対性指数 (RSI)",
                "indicatorsRSIPeriod": "期間",
                "indicatorsROC": "変化率 (ROC)",
                "indicatorsROCPeriod": "期間",
                'indicatorsCCI': 'ホメオパシー指標(CCI)',
                'indicatorsCCIPeriod': '期間',
                "indicatorsSMAR": "ウィリアム%R",
                "indicatorsSMAPeriod": "期間",
                "indicatorsSMASlow": "スロー・ストキャスティクス",
                "indicatorsSMAK": "%K 期間",
                "indicatorsSMAD": "%D 期間",
                "indicatorsSMAFast": "ファスト・ストキャスティクス",
                "indicatorsSMAFastK": "%K 期間",
                "indicatorsSMAFastD": "%D 期間",
                "indicatorsSMAPrice": "プライス・チャネル",
                "indicatorsSMAPriceChannel": "プライス・チャネル",
                "indicatorsSMAMA": "MAエンベロープ",
                "indicatorsSMAMAPeriod": "期間",
                "indicatorsSMAMABand": "バンド幅",
                "indicatorsSMAMomentum": "モメンタム",
                "indicatorsSMAMomentumPeriod": "期間",
                "indicatorsSMAULT": "究極の(ULT)オシレーター",
                "indicatorsSMADMI": "方向性指数 (DMI)",
                "indicatorsSMADMIPeriod": "期間",
                "indicatorsSMAMoney": "マネー・フロー・インデックス",
                "indicatorsSMAMoneyPeriod": "期間",
                "indicatorsSMAOBV": "オンバランス・ボリューム",
                "indicatorsEMAVol": "ボリューム・アキュミュレーション",
                "indicatorsEMADirect": "騰落レシオ",
                "indicatorsEMADirectPeriodo": "期間",
                "indicatorsEMADirectSmoothing": "スムージング",
                "indicatorsEMAVolume": "価格帯別出来高",
                "indicatorsEMAFast": "ファスト・ボラティリティ",
                "indicatorsEMAWeight": "加重移動平均線 (WMA)",
                "indicatorsEMAWeightPeriodo": "期間",
                "indicatorsEMAAD": "A/D 累積/分散",
                "indicatorsEMAMass": "マス・インデックス",
                "indicatorsEMAVolat": "ボラティリティ",
                "indicatorsEMAVolatPeriod": "期間",
                "indicatorsEMAVolatPeriodA": "期間 (前)",
                "indicatorsEMAForce": "勢力指数",
                "indicatorsEMAForcePeriod": "期間",
                "indicatorsEMARange": "アベレージ・トゥルー・レンジ (ATR)",
                "indicatorsVolumeKeltner": "ケルトナー・チャネルズ",
                "indicatorsVolumeKeltnerEMA": "EMA期間",
                "indicatorsVolumeKeltnerTimes": "倍率",
                "indicatorsVolumeKeltnerATR": "ATR期間",
                "indicatorsVolumePrevious": "前営業日終値",
                "performanceGrowthChart": "累積パフォーマンス・チャート",
                "pricesGrowthChart": "価格成長率チャート",
                "performanceGrowthChartance": "パフォーマンス…",
                "update": "更新",
                "fundamentals": "各種指標",
                "priceEarnings": "PER (株価/利益)",
                "priceSales": "PSR (株価/売上高)",
                "priceBook": "PBR (株価/純資産)",
                "priceCash": "PCFR (株価/キャッシュフロー)",
                "fairValue": "適正価値推計値",
                "rollingDividend": "配当推移",
                "dividendYield": "配当利回り",
                "rollingEPS": "EPS推移",
                "drawings": "描画ツール",
                "trendLine": "トレンドライン",
                "rectangle": "長方形",
                "ellipse": "楕円",
                "levelLine": "水平線",
                "fibonacciRL": "フィボナッチ・リトレースメント・レベル",
                "fibonacciFans": "フィナボッチ・ファン",
                "fibonacciTZ": "フィナボッチ・タイムゾーン",
                "fibonacciArcs": "フィナボッチ・アーク",
                "shortInt": "% 空売り残高",
                "priceEarnings0": "割引適正価値",
                "priceEarnings1": "基準価額",
                "priceEarnings2": "プレミアム/ディスカウント",
                "display": "表示",
                "cursorType": "カーソル・タイプ",
                "crosshair": "十字",
                "trackBall": "丸",
                "off": "オフ",
                "chartType": "チャート形式",
                "mountain": "面",
                "line": "線",
                "dot": "点",
                "aboveBelow": "上昇/下落",
                "OHLC": "四本値",
                "HLC": "三本値",
                "candlestick": "ローソク足",
                "growth": "累積騰落率",
                "10KGrowth": "累積資産額",
                "priceWithDividendGrowth": "分配金込み基準価額",
                "dividendEffect": "配当効果",
                "postTax": "税引き後リターン",
                "yAxis": "Y軸位置",
                "left": "左",
                "right": "右",
                "verticalScale": "縦軸スケール",
                "linear": "指数",
                "logarithmic": "対数",
                "selectionMode": "選択時動作",
                "pan": "平行移動",
                "zoomIn": "拡大",
                "reset": "リセット",
                "other": "その他",
                "extendedMarketHour": "時間外取引",
                "volumePlus": "出来高+",
                'oneMinute': "1 分",
                'fiveMinute': "5 分",
                'tenMinute': "10 分",
                'fifteenMinute': "15 分",
                'thirtyMinute': "30 分",
                'sixtyMinute': "60 分",
                'daily': "日次",
                'weekly': "週次",
                'monthly': "月次",
                "date": "日付",
                "time": "時間",
                "nav": "基準価額",
                'oneMinuteValueChange': '1 分 変更',
                'oneMinuteValueChangePercent': '1 min % 変化率',
                'fiveMinuteValueChange': "5 分 変更",
                'fiveMinuteValueChangePercent': "5 分 % 変化率",
                'tenMinuteValueChange': "10 分 変更",
                'tenMinuteValueChangePercent': "10 分 % 変化率",
                'fifteenMinuteValueChange': "15 分 変更",
                'fifteenMinuteValueChangePercent': "15 分 % 変化率",
                'thirtyMinuteValueChange': "30 分 変更",
                'thirtyMinuteValueChangePercent': "30 分 % 変化率",
                'sixtyMinuteValueChange': "60 分 変更",
                'sixtyMinuteValueChangePercent': "60 分 % 変化率",
                'dailyValueChange': "毎日 変更",
                'dailyValueChangePercent': "毎日 % 変化率",
                'weeklyValueChange': "毎週 変更",
                'weeklyValueChangePercent': "毎週 % 変化率",
                'monthlyValueChange': "毎月 変更",
                'monthlyValueChangePercent': "毎月 % 変化率",
                "totalReturn": "トータル・リターン",
                "marketValue": "市場価値",
                "open": "始値",
                "close": "終値",
                "low": "安値",
                "high": "高値",
                "volume": "出来高",
                "value": "値",
                "semiAnnual": "半年",
                "annual": "年",
                "quarterly": "四半期",
                "mainGrowthLabel": "Performance Fondo",
                "compareGrowthLabel": "Performance Benchmark",
                "closeDateLabel": "Data Chiusura Mercato",
                "range": "範囲",
                "datanotavailable": "データがありません。",
                "mifidRuleMessage": "このグラフと関連データは、ファンドの開設日から{0}か月後に利用可能になります。",
                "changetodailyfrequency": "これは日次のデータ項目です。 | 頻度を日次に変更してください。",
                "tenKGrowth": "累積資産額",
                "postTax": "税引き後リターン",
                "addComparison": "比較対象を追加",
                "searchAssets": "検索",
                "crosshairsPopoverNoData": "--",
                "mainChartHeaderDividendEffectLabel": "(含む配当)",
                "compareChartsMaxAllowedErrorLabel": "これ以上比較対象を追加できません。",
                "oneDay": "1日",
                "fiveDay": "5日",
                "fifteenDay": "15日",
                "oneMonth": "1ヶ月",
                "threeMonth": "3ヶ月",
                "sixMonth": "6ヶ月",
                "YTD": "年初来",
                "oneYear": "1年",
                "threeYear": "3年",
                "fiveYear": "5年",
                "tenYear": "10年",
                "max": "最大",
                "to": "～",
                "frequencys": "頻度",
                "dividendText": "配",
                "splitText": "分",
                "earningText": "利",
                "settings": "設定",
                "optionsBtnText": "オプション",
                "export": "出力",
                "print": "印刷",
                "closeBtnText": "閉じる",
                "errorsMsg": "この携帯端末ではチャートを全て表示できません。タブレット端末もしくはPCからご利用ください。",
                'fundSize': '基金のサイズ',
                'price': '価格',
                'shareholdersNumber': '株主数',
                'name': '名',
                'PE': 'PER (株価/利益)',
                'PS': 'PSR (株価/売上高)',
                'PB': 'PBR (株価/純資産)',
                'PC': 'PCFR (株価/キャッシュフロー)',
                'FairValue': 'Fair Value',
                'RDividend': '配当推移',
                'DYield': '配当利回り',
                'REPS': 'EPS推移',
                'PremiumDiscount': 'プレミアム/ディスカウント',
                'DiscountCumFair': '割引適正価値',
                'SInterest': '% 空売り残高',
                'SMA': 'SMA',
                'EMA': 'EMA',
                'SMAV': 'SMAV',
                'BBands': 'BB',
                'PSAR': 'PSAR',
                'RSI': '相対性指数 (RSI)',
                'ROC': '変化率 (ROC)',
                'CCI': 'CCI',
                'WillR': 'ウィリアム%R',
                'SStochastic': 'スロー・ストキャスティクス',
                'FStochastic': 'ファスト・ストキャスティクス',
                'PChannel': 'PChannel',
                'MAE': 'MAエンベロープ',
                'Momentum': 'モメンタム',
                'ULT': '究極の(ULT)オシレーター',
                'MFI': 'マネー・フロー・インデックス',
                'OBV': 'オンバランス・ボリューム',
                'VAcc': 'ボリューム・アキュミュレーシ',
                'UDRatio': '騰落レシオ',
                'FVolatility': 'ファスト・ボラティリティ',
                'WMA': 'WMA',
                'AccDis': 'A/D 累積/分散',
                'Mass': 'マス・インデックス',
                'Volatility': 'ボラティリティ',
                'ForceIndex': '勢力指数',
                'ATR': 'アベレージ・トゥルー・レン',
                'Keltner': 'Keltnerチャネルズ',
                'VBP': 'VBP',
                'DMI': ['DMI+', ' DMI-', ' ADX'],
                'MACD': ['MACD', 'EMA', 'Divergence'],
                'PrevClose': '前営業日終値',
                "mutualFund": "ファンド",
                "closedEndFund": "クローズドエンドファンド",
                "equities": "株式",
                "index": "インデックス",
                "eTF": "ETF",
                "commonStocks": "普通株式",
                "preferredStocks": "優先株式",
                "aDRs": "ADRs",
                "options": "オプション",
                "futures": "先物",
                "debenture": "债券",
                "governmentBonds": "国債",
                "municipalBonds": "市債",
                "strategiesSpreads": "戦略とコミュニケーション",
                "unspecifiedBonds": "不特定の債券",
                "unspecifiedFundsCertificates": "不特定の資金と証明書",
                "warrants": "认ワラント股权证",
                "forex": "外国為替",
                "startDate": "開始日",
                "earliest": "最長",
                "common": "共通",
                "mainTicker": "主銘柄",
                "startDateIllustrate": "比較時の基準日を選択"
            },
            'da': {
                "invalidInputDefault": "Indtast venligst et positivt tal",
                "invalidInputNpi": "Indtast venligst et positivt tal",
                "frequency": "Frekvens",
                "dataRange": "Datointerval",
                "customDate": "Tilpasset Dato",
                "customStartDate": "Start Dato",
                "customEndDate": "Slut Dato",
                "labelSearch": "Tilføj instrumenter til sammenligning",
                "labelChange": "Skift Primær Ticker",
                "eventsIndicators": "Begivenheder & Indikatorer",
                "events": "Begivenheder",
                "eventsDividende": "Udbytte",
                "eventsSplits": "Aktiesplit",
                "eventsEarnings": "Regnskaber",
                "indicators": "Indikatorer",
                "indicatorsSMA": "Simple Moving Average (SMA)",
                "indicatorsSMAlabel1": "Linje 1 Periode",
                "indicatorsSMAlabel2": "Linje 2 Periode",
                "indicatorsSMAlabel3": "Linje 3 Periode",
                "indicatorsEMA": "Exponential Moving Average (EMA)",
                "indicatorsEMAlabel1": "Linje 1 Periode",
                "indicatorsEMAlabel2": "Linje 2 Periode",
                "indicatorsEMAlabel3": "Linje 3 Periode",
                "indicatorsVolume": "Volume",
                "indicatorsVolumeSMA": "Volume SMA",
                "indicatorsPeriod": "Period",
                "indicatorsBBands": "Bollinger Bands (BBands)",
                "indicatorsBBandsPeriod": "Period",
                "indicatorsBBandsDeviation": "Deviation",
                "indicatorsPSAR": "Parabolic SAR (PSAR)",
                "indicatorsPSARStep": "Step Period",
                "indicatorsPSARMaxStep": "Max Step Period",
                "indicatorsMACD": "MACD",
                "indicatorsMACDSlow": "Slow Period",
                "indicatorsMACDFast": "Fast Period",
                "indicatorsMACDSignal": "Signal Period",
                "indicatorsRSI": "Relative Strength Index (RSI)",
                "indicatorsRSIPeriod": "Period",
                "indicatorsROC": "Rate of Change (ROC)",
                "indicatorsROCPeriod": "Period",
                'indicatorsCCI': 'Commodity Channel Index (CCI)',
                'indicatorsCCIPeriod': 'Period',
                "indicatorsSMAR": "Williams %R",
                "indicatorsSMAPeriod": "Period",
                "indicatorsSMASlow": "Slow Stochastic",
                "indicatorsSMAK": "K% Period",
                "indicatorsSMAD": "D% Period",
                "indicatorsSMAFast": "Fast Stochastic",
                "indicatorsSMAFastK": "K% Period",
                "indicatorsSMAFastD": "D% Period",
                "indicatorsSMAPrice": "Price Channel",
                "indicatorsSMAPriceChannel": "Price Channel",
                "indicatorsSMAMA": "MA Envelope",
                "indicatorsSMAMAPeriod": "Period",
                "indicatorsSMAMABand": "Band Width",
                "indicatorsSMAMomentum": "Momentum",
                "indicatorsSMAMomentumPeriod": "Period",
                "indicatorsSMAULT": "Ultimate (ULT) Oscillator",
                "indicatorsSMADMI": "Directional Moving Index (DMI)",
                "indicatorsSMADMIPeriod": "Period",
                "indicatorsSMAMoney": "Money Flow Index",
                "indicatorsSMAMoneyPeriod": "Period",
                "indicatorsSMAOBV": "On Balance Volume",
                "indicatorsEMAVol": "Volume Accumulation",
                "indicatorsEMADirect": "Up/Down Ratio",
                "indicatorsEMADirectPeriodo": "Period",
                "indicatorsEMADirectSmoothing": "Smoothing",
                "indicatorsEMAVolume": "Volume By Price",
                "indicatorsEMAFast": "Fast Volatility",
                "indicatorsEMAWeight": "Weighted Moving Average",
                "indicatorsEMAWeightPeriodo": "Period",
                "indicatorsEMAAD": "Accumulation/Distribution",
                "indicatorsEMAMass": "Mass Index",
                "indicatorsEMAVolat": "Volatility",
                "indicatorsEMAVolatPeriod": "Period",
                "indicatorsEMAVolatPeriodA": "Period Ago",
                "indicatorsEMAForce": "Force Index",
                "indicatorsEMAForcePeriod": "Period",
                "indicatorsEMARange": "Average True Range",
                "indicatorsVolumeKeltner": "Keltner Index",
                "indicatorsVolumeKeltnerEMA": "EMA Period",
                "indicatorsVolumeKeltnerTimes": "Times",
                "indicatorsVolumeKeltnerATR": "ATR Period",
                "indicatorsVolumePrevious": "Previous Close Line",
                "performanceGrowthChart": "Vækst Graf (Afkast)",
                "pricesGrowthChart": "Vækst Graf (Pris)",
                "performanceGrowthChartance": "Afkast...",
                "update": "Opdatér",
                "fundamentals": "Fundamentaler",
                "priceEarnings": "Price/Earnings",
                "priceSales": "Price/Sales",
                "priceBook": "Price/Book",
                "priceCash": "Price/Cash",
                "fairValue": "Fair Value",
                "rollingDividend": "Løbende Udbytte",
                "dividendYield": "Udbytteprocent",
                "rollingEPS": "Løbende EPS",
                "drawings": "Tegn",
                "trendLine": "Trend Linje",
                "rectangle": "Rektangel",
                "ellipse": "Ellipse",
                "levelLine": "Niveau Linje",
                "fibonacciRL": "Fibonacci Retracement Levels",
                "fibonacciFans": "Fibonacci Fans",
                "fibonacciTZ": "Fibonacci Time Zones",
                "fibonacciArcs": "Fibonacci Arcs",
                "shortInt": "% Short Interesse",
                "priceEarnings0": "Nutidsværdi",
                "priceEarnings1": "NAV",
                "priceEarnings2": "Præmie/Discount",
                "display": "Vis",
                "cursorType": "Markør",
                "crosshair": "Kryds",
                "trackBall": "Cirkel",
                "off": "Fra",
                "chartType": "Graf",
                "mountain": "Bjerg",
                "line": "Linje",
                "dot": "Prik",
                "aboveBelow": "Over/Under",
                "OHLC": "OHLC",
                "HLC": "HLC",
                "candlestick": "Candlestick",
                "growth": "Vækst",
                "10KGrowth": "10K Vækst",
                "priceWithDividendGrowth": "Pris med udbyttevækst",
                "dividendEffect": "Udbytte Effekt",
                "postTax": "Før Skat Afkast",
                "yAxis": "Y-Akse",
                "left": "Venstre",
                "right": "Højre",
                "verticalScale": "Vertikal Skala",
                "linear": "Lineær",
                "logarithmic": "Logaritmisk",
                "selectionMode": "Selection Mode",
                "pan": "Ryk",
                "zoomIn": "Zoom Ind",
                "reset": "Nulstil",
                "other": "Andet",
                "extendedMarketHour": "Extended Market Hour",
                "volumePlus": "Volume+",
                "oneMinute": "1 min.",
                "fiveMinute": "5 min.",
                "tenMinute": "10 min.",
                "fifteenMinute": "15 min.",
                "thirtyMinute": "30 min.",
                "sixtyMinute": "60 min.",
                "daily": "Daglig",
                "weekly": "Ugentlig",
                "monthly": "Månedlig",
                "date": "Dato",
                "time": "Tid",
                "nav": "NAV",
                "oneMinuteValueChange": "1 min. Ændring",
                "oneMinuteValueChangePercent": "1 min. Ændring (%)",
                "fiveMinuteValueChange": "5 min. Ændring",
                "fiveMinuteValueChangePercent": "5 min. Ændring (%)",
                "tenMinuteValueChange": "10 min. Ændring",
                "tenMinuteValueChangePercent": "10 min. Ændring (%)",
                "fifteenMinuteValueChange": "15 min. Ændring",
                "fifteenMinuteValueChangePercent": "15 min. Ændring (%)",
                "thirtyMinuteValueChange": "30 min. Ændring",
                "thirtyMinuteValueChangePercent": "30 min. Ændring (%)",
                "sixtyMinuteValueChange": "60 min. Ændring",
                "sixtyMinuteValueChangePercent": "60 min. Ændring (%)",
                "dailyValueChange": "Daglig Ændring",
                "dailyValueChangePercent": "Daglig Ændring (%)",
                "weeklyValueChange": "Ugentlig Ændring",
                "weeklyValueChangePercent": "Ugentlig Ændring (%)",
                "monthlyValueChange": "Månedlig Ændring",
                "monthlyValueChangePercent": "Månedlig Ændring (%)",
                "totalReturn": "Afkast I Alt",
                "marketValue": "Markedsværdi",
                "open": "Åbningskurs",
                "close": "Lukkekurs",
                "low": "Laveste",
                "high": "Højeste",
                "volume": "Volumen",
                "value": "Værdi",
                "semiAnnual": "Semi-årlig",
                "annual": "Årlig",
                "quarterly": "Kvartalsvis",
                "mainGrowthLabel": "Performance Fond",
                "compareGrowthLabel": "Performance Benchmark",
                "closeDateLabel": "Sidste handelsdag",
                "range": "Interval",
                "datanotavailable": "Utilgængelig Data",
                "mifidRuleMessage": "Denne graf og de relaterede data vil være tilgængelige {0} måneder efter fondens startdato",
                "changetodailyfrequency": "Dette er et dagligt datapunkt. | Skift venligst din frekvens til Daglig.",
                "tenKGrowth": "10K Vækst",
                "postTax": "Før Skat Afkast",
                "addComparison": "Tilføj Sammenligning",
                "changeTicker": "Skift Ticker",
                "searchAssets": "Søg efter aktiver",
                "crosshairsPopoverNoData": "--",
                "mainChartHeaderDividendEffectLabel": "(med Udb.)",
                "compareChartsMaxAllowedErrorLabel": "Det maksimale antal sammenlignelige tickers er nået.",
                "oneDay": "1D",
                "fiveDay": "5D",
                "fifteenDay": "15D",
                "oneMonth": "1M",
                "threeMonth": "3M",
                "sixMonth": "6M",
                "YTD": "ÅTD",
                "oneYear": "1 År",
                "threeYear": "3 År",
                "fiveYear": "5 År",
                "tenYear": "10 År",
                "max": "MAX",
                "to": "til",
                "frequencys": "frekvens",
                "dividendText": "U",
                "splitText": "S",
                "earningText": "I",
                "settings": "Indstillinger",
                "options": "Muligheder",
                "export": "Eksportér",
                "print": "Print",
                "errorsMsg": "Din mobile enhed kan ikke vise nogle af grafens funktioner. Log ind fra en tablet eller computer for at få den mest optimale oplevelse.",
                "fundSize": "Fond Størrelse",
                "price": "Pris",
                "shareholdersNumber": "Antal aktionærer",
                "name": "Navn",
                'PE': 'Price/Earnings',
                'PS': 'Price/Sales',
                'PB': 'Price/Book',
                'PC': 'Price/Cash',
                'FairValue': 'Fair Value',
                'DailyCumFairNav': 'NAV',
                'QuantitativeFairValue': 'Fair Value',
                'RDividend': 'Løbende Dividend',
                'DYield': 'Dividend Yield',
                'REPS': 'Løbende EPS',
                'PremiumDiscount': 'Premium/Discount',
                "DiscountCumFair": "Nutidsværdi",
                'SInterest': '% Short Int.',
                'SMA': 'SMA',
                'EMA': 'EMA',
                'SMAV': 'SMAV',
                'BBands': 'BBands',
                'PSAR': 'PSAR',
                'RSI': 'RSI',
                'ROC': 'ROC',
                'CCI': 'CCI',
                'WillR': 'WillR',
                'SStochastic': 'SStochastic',
                'FStochastic': 'FStochastic',
                'PChannel': 'PChannel',
                'MAE': 'MA Envelope',
                'Momentum': 'Momentum',
                'ULT': 'Ultimate Oscillator',
                'MFI': 'MFI',
                'OBV': 'On Balance Volume',
                'VAcc': 'Volume Accumulation',
                'UDRatio': 'UDRatio',
                'FVolatility': 'Fast Volatility',
                'WMA': 'WMA',
                'AccDis': 'Accumulation/Distribution',
                'Mass': 'Mass',
                'Volatility': 'Volatility',
                'ForceIndex': 'ForceIndex',
                'ATR': 'Average True Range',
                'Keltner': 'Keltner Index',
                'VBP': 'VBP',
                'DMI': ['DMI+', ' DMI-', ' ADX'],
                'MACD': ['MACD', 'EMA', 'Divergence'],
                'PrevClose': 'tidligere tæt',
                "mutualFund": "Investeringsforening",
                "closedEndFund": "Closed-End Fund",
                "equities": "Aktier",
                "index": "Index",
                "eTF": "ETF",
                "commonStocks": "Ordinære aktier",
                "preferredStocks": "Præferenceaktier",
                "aDRs": "ADRs",
                "options": "Optioner",
                "futures": "Futures",
                "debenture": "Partialobligation",
                "governmentBonds": "Statsobligationer",
                "municipalBonds": "Municipal Bonds",
                "strategiesSpreads": "Strategier & Spreads",
                "unspecifiedBonds": "Ikke Klassificerede Obligationer",
                "unspecifiedFundsCertificates": "Ikke Klassificerede Fonde & Certifikater",
                "warrants": "Warrants",
                "forex": "Valuta",
                "startDate": "Start Date",
                "earliest": "Earliest",
                "common": "Common",
                "mainTicker": "Main Ticker",
                "startDateIllustrate": "Indicate the base date when comparison added"
            },
            'sv': {
                "invalidInputDefault": "Vänligen skriv in ett positivt heltal eller lämna blankt",
                "invalidInputNpi": "Vänligen skriv in ett positivt heltal",
                "frequency": "Frekvens",
                "dataRange": "Datumintervall",
                "customDate": "Egenvald tidsperiod",
                "customStartDate": "Startdatum",
                "customEndDate": "Slutdatum",
                "labelSearch": "Lägg till jämförelse",
                "labelChange": "Ändra huvudinstrument",
                "eventsIndicators": "Händelser & Indikatorer",
                "events": "Händelser",
                "eventsDividende": "Utdelning",
                "eventsSplits": "Splittar",
                "eventsEarnings": "Earnings",
                "indicators": "Indikatorer",
                "indicatorsSMA": "Simple Moving Average (SMA)",
                "indicatorsSMAlabel1": "Line1 period",
                "indicatorsSMAlabel2": "Line2 period",
                "indicatorsSMAlabel3": "Line3 period",
                "indicatorsEMA": "Exponential Moving Average (EMA)",
                "indicatorsEMAlabel1": "Line1 period",
                "indicatorsEMAlabel2": "Line2 period",
                "indicatorsEMAlabel3": "Line3 period",
                "indicatorsVolume": "Volume",
                "indicatorsVolumeSMA": "Volume SMA",
                "indicatorsPeriod": "Period",
                "indicatorsBBands": "Bollinger Bands (BBands)",
                "indicatorsBBandsPeriod": "Period",
                "indicatorsBBandsDeviation": "Deviation",
                "indicatorsPSAR": "Parabolic SAR (PSAR)",
                "indicatorsPSARStep": "Step Period",
                "indicatorsPSARMaxStep": "Max Step Period",
                "indicatorsMACD": "MACD",
                "indicatorsMACDSlow": "Slow Period",
                "indicatorsMACDFast": "Fast Period",
                "indicatorsMACDSignal": "Signal Period",
                "indicatorsRSI": "Relative Strength Index (RSI)",
                "indicatorsRSIPeriod": "Period",
                "indicatorsROC": "Rate of Change (ROC)",
                "indicatorsROCPeriod": "Period",
                'indicatorsCCI': 'Commodity Channel Index (CCI)',
                'indicatorsCCIPeriod': 'Period',
                "indicatorsSMAR": "Williams %R",
                "indicatorsSMAPeriod": "Period",
                "indicatorsSMASlow": "Slow Stochastic",
                "indicatorsSMAK": "K% Period",
                "indicatorsSMAD": "D% Period",
                "indicatorsSMAFast": "Fast Stochastic",
                "indicatorsSMAFastK": "K% Period",
                "indicatorsSMAFastD": "D% Period",
                "indicatorsSMAPrice": "Price Channel",
                "indicatorsSMAPriceChannel": "Price Channel",
                "indicatorsSMAMA": "MA Envelope",
                "indicatorsSMAMAPeriod": "Period",
                "indicatorsSMAMABand": "Band Width",
                "indicatorsSMAMomentum": "Momentum",
                "indicatorsSMAMomentumPeriod": "Period",
                "indicatorsSMAULT": "Ultimate (ULT) Oscillator",
                "indicatorsSMADMI": "Directional Moving Index (DMI)",
                "indicatorsSMADMIPeriod": "Period",
                "indicatorsSMAMoney": "Money Flow Index",
                "indicatorsSMAMoneyPeriod": "Period",
                "indicatorsSMAOBV": "On Balance Volume",
                "indicatorsEMAVol": "Volume Accumulation",
                "indicatorsEMADirect": "Up/Down Ratio",
                "indicatorsEMADirectPeriodo": "Period",
                "indicatorsEMADirectSmoothing": "Smoothing",
                "indicatorsEMAVolume": "Volume By Price",
                "indicatorsEMAFast": "Fast Volatility",
                "indicatorsEMAWeight": "Weighted Moving Average",
                "indicatorsEMAWeightPeriodo": "Period",
                "indicatorsEMAAD": "Accumulation/Distribution",
                "indicatorsEMAMass": "Mass Index",
                "indicatorsEMAVolat": "Volatility",
                "indicatorsEMAVolatPeriod": "Period",
                "indicatorsEMAVolatPeriodA": "Period Ago",
                "indicatorsEMAForce": "Force Index",
                "indicatorsEMAForcePeriod": "Period",
                "indicatorsEMARange": "Average True Range",
                "indicatorsVolumeKeltner": "Keltner Index",
                "indicatorsVolumeKeltnerEMA": "EMA Period",
                "indicatorsVolumeKeltnerTimes": "Times",
                "indicatorsVolumeKeltnerATR": "ATR Period",
                "indicatorsVolumePrevious": "Previous Close Line",
                "performanceGrowthChart": "Performance Growth Chart",
                "pricesGrowthChart": "Prices Growth Chart",
                "performanceGrowthChartance": "Performance...",
                "update": "Uppdatera",
                "fundamentals": "Fundamentals",
                "priceEarnings": "Price/Earnings",
                "priceSales": "Price/Sales",
                "priceBook": "Price/Book",
                "priceCash": "Price/Cash",
                "fairValue": "Fair Value",
                "rollingDividend": "Rolling Dividend",
                "dividendYield": "Dividend Yield",
                "rollingEPS": "Rolling EPS",
                "drawings": "Drawings",
                "trendLine": "Trend Line",
                "rectangle": "Rectangle",
                "ellipse": "Ellipse",
                "levelLine": "Level Line",
                "fibonacciRL": "Fibonacci Retracement Levels",
                "fibonacciFans": "Fibonacci Fans",
                "fibonacciTZ": "Fibonacci Time Zones",
                "fibonacciArcs": "Fibonacci Arcs",
                "shortInt": "% Short Int.",
                "priceEarnings0": "Discount Cum Fair",
                "priceEarnings1": "NAV",
                "priceEarnings2": "Premium/Discount",
                "display": "Display",
                "cursorType": "Markörstyp",
                "crosshair": "Hårkors",
                "trackBall": "Spårboll",
                "off": "av",
                "chartType": "Graftyp",
                "mountain": "Berg",
                "line": "Linje",
                "dot": "Punkt",
                "aboveBelow": "Above/Below",
                "OHLC": "OHLC",
                "HLC": "HLC",
                "candlestick": "Candlestick",
                "growth": "Tillväxt",
                "10KGrowth": "10K Growth",
                "priceWithDividendGrowth": "Pris med utdelningstillväxt",
                "dividendEffect": "Dividend Effect",
                "postTax": "Post Tax Return",
                "yAxis": "Y-axeln",
                "left": "Vänster",
                "right": "Höger",
                "verticalScale": "Vertikal skala",
                "linear": "Linjär",
                "logarithmic": "Logaritmisk",
                "selectionMode": "Urvalsläge",
                "pan": "Pan",
                "zoomIn": "Zooma in",
                "reset": "Återställ",
                "other": "Andra",
                "extendedMarketHour": "Extended Market Hour",
                "volumePlus": "Volume+",
                "oneMinute": "1 min",
                "fiveMinute": "5 min",
                "tenMinute": "10 min",
                "fifteenMinute": "15 min",
                "thirtyMinute": "30 min",
                "sixtyMinute": "60 min",
                "daily": "Daglig",
                "weekly": "Veckovis",
                "monthly": "Månadsvis",
                "date": "Datum",
                "time": "Tid",
                "nav": "NAV",
                "oneMinuteValueChange": "1 min förändring",
                "oneMinuteValueChangePercent": "1 min% förändring",
                "fiveMinuteValueChange": "5 min förändring",
                "fiveMinuteValueChangePercent": "5 min% förändring",
                "tenMinuteValueChange": "10 min förändring",
                "tenMinuteValueChangePercent": "10 min% förändring",
                "fifteenMinuteValueChange": "15 min förändring",
                "fifteenMinuteValueChangePercent": "15 min% förändring",
                "thirtyMinuteValueChange": "30 min förändring",
                "thirtyMinuteValueChangePercent": "30 min% förändring",
                "sixtyMinuteValueChange": "60 min förändring",
                "sixtyMinuteValueChangePercent": "60 min% förändring",
                "dailyValueChange": "Daglig förändring",
                "dailyValueChangePercent": "Daglig förändring i %",
                "weeklyValueChange": "Veckovis förändring",
                "weeklyValueChangePercent": "Veckovis förändring i %",
                "monthlyValueChange": "Månatlig förändring",
                "monthlyValueChangePercent": "Månatlig ändring i %",
                "totalReturn": "Totalavkastning",
                "marketValue": "Marknadsvärde",
                "open": "Öppna",
                "close": "Stäng",
                "low": "Lägst",
                "high": "Högst",
                "volume": "Volym",
                "value": "Värde",
                "semiAnnual": "Halvår",
                "annual": "Helår",
                "quarterly": "Kvartal",
                "mainGrowthLabel": "Utveckling Fond",
                "compareGrowthLabel": "Utveckling Index",
                "closeDateLabel": "Data Chiusura Mercato",
                "range": "Intervall",
                "datanotavailable": "Data saknas",
                "mifidRuleMessage": "Denna graf och de relaterade uppgifterna kommer att finnas tillgängliga {0} månader efter fondens startdatum",
                "changetodailyfrequency": "Detta är en dagligt uppdaterad datapunkt. |Vänligen ändra frekvensen till daglig för att se datapunkten.",
                "tenKGrowth": "Utvecklingen av 10 000",
                "postTax": "Post Tax Return",
                "addComparison": "Lägg till jämförelse",
                "changeTicker": "Ändra ticker",
                "searchAssets": "Sök instrument",
                "crosshairsPopoverNoData": "--",
                "mainChartHeaderDividendEffectLabel": "(w Div.)",
                "compareChartsMaxAllowedErrorLabel": "'Gränsen för max antal instrument i jämförelsen är nådd, vänligen ta bort ett eller flera instrument",
                "oneDay": "1 d",
                "fiveDay": "5 d",
                "fifteenDay": "15 d",
                "oneMonth": "1 m",
                "threeMonth": "3 m",
                "sixMonth": "6 m",
                "YTD": "i år",
                "oneYear": "1 år",
                "threeYear": "3 år",
                "fiveYear": "5 år",
                "tenYear": "10 år",
                "max": "MAX",
                "to": "till",
                "frequencys": "Frekvens",
                "dividendText": "D",
                "splitText": "S",
                "earningText": "E",
                "settings": "Inställningar",
                "optionsBtnText": "Alternativ",
                "export": "Exportera",
                "print": "Print",
                "closeBtnText": "Stäng",
                "errorsMsg": "Din enhet kan inte utnyttja all funktionalitet i grafen, vänligen använd en dator för full funktionalitet",
                "fundSize": "Fondstorlek",
                "price": "Pris",
                "shareholdersNumber": "Antal aktieägare",
                "name": "Namn",
                "PE": "Price/Earnings",
                "PS": "Price/Sales",
                "PB": "Price/Book",
                "PC": "Price/Cash",
                "FairValue": "Fair Value",
                "DailyCumFairNav": "NAV",
                "QuantitativeFairValue": "Fair Value",
                "RDividend": "Rolling Dividend",
                "DYield": "Dividend Yield",
                "REPS": "Rolling EPS",
                "DiscountCumFair": "Discount Cum Fair",
                "PremiumDiscount": "Premium/Discount",
                "SInterest": "% Short Int.",
                "SMA": "SMA",
                "EMA": "EMA",
                "SMAV": "SMAV",
                "BBands": "BBands",
                "PSAR": "PSAR",
                "RSI": "RSI",
                "ROC": "ROC",
                'CCI': 'CCI',
                "WillR": "WillR",
                "SStochastic": "SStochastic",
                "FStochastic": "FStochastic",
                "PChannel": "PChannel",
                "MAE": "MA Envelope",
                "Momentum": "Momentum",
                "ULT": "Ultimate Oscillator",
                "MFI": "MFI",
                "OBV": "On Balance Volume",
                "VAcc": "Volume Accumulation",
                "UDRatio": "UDRatio",
                "FVolatility": "Fast Volatility",
                "WMA": "WMA",
                "AccDis": "Accumulation/Distribution",
                "Mass": "Mass",
                "Volatility": "Volatility",
                "ForceIndex": "ForceIndex",
                "ATR": "Average True Range",
                "Keltner": "Keltner Index",
                "VBP": "VBP",
                "DMI": ["DMI+", " DMI-", " ADX"],
                "MACD": ["MACD", "EMA", "Divergence"],
                'PrevClose': 'föregående stäng',
                "mutualFund": "Mutual Fund",
                "closedEndFund": "Closed-End Fund",
                "equities": "Aktier",
                "index": "Index",
                "eTF": "ETF",
                "commonStocks": "Stamaktier",
                "preferredStocks": "Preferensaktier",
                "aDRs": "ADRs",
                "options": "Optioner",
                "futures": "Terminer",
                "debenture": "Debenture",
                "governmentBonds": "Stadsobligationer",
                "municipalBonds": "Kommunala obligationer",
                "strategiesSpreads": "Strategies & Spreads",
                "unspecifiedBonds": "Ospecificierade obligationer",
                "unspecifiedFundsCertificates": "Ospecificierade fonder & certifikat",
                "warrants": "Warranter",
                "forex": "Forex",
                "startDate": "Start Date",
                "earliest": "Earliest",
                "common": "Common",
                "mainTicker": "Main Ticker",
                "startDateIllustrate": "Indicate the base date when comparison added"
            }
        }
    };
});


//////////////////
// WEBPACK FOOTER
// ./components/svgchart/src/js/manager/chartConfig/languageConfig.js
// module id = 58
// module chunks = 0